import React, { useEffect, useRef, useState, useCallback } from 'react';
import ScriptDialog from 'app/fuse-layouts/shared-components/ScriptDialog';
import VolumeManager from '../components/VolumeManager';
import VolumeDetailsDialog from '../components/VolumeDetailsDialog';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    Icon,
    IconButton,
    InputBase,
    FormControl,
    FormControlLabel,
    MenuItem,
    Paper,
    Popover,
    Radio,
    RadioGroup,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    InputAdornment,
    Menu,
    Card,
    CardHeader,
    CardContent,
    Box,
    Tooltip,
    Chip,
    DialogContentText,
    Select,
    InputLabel,
    Switch
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import clsx from 'clsx';
import * as StackActions from 'app/main/stacks/store/actions/stacks.actions.js';
import * as MarketActions from 'app/main/marketplace/store/actions';
import Formsy from 'formsy-react';
import { CheckboxFormsy, FuseAnimate, SelectFormsy, TextFieldFormsy } from '@fuse';
import { useForm } from '@fuse/hooks';
import _ from '@lodash';
import { useDispatch, useSelector } from 'react-redux';
import * as ActionsDialog from 'app/store/actions';
import * as Actions from '../store/actions';
import { getStorageProviders } from '../store/actions/cluster.actions';
import { ipValid, setinstancesVol, validationInputUlt, validationMessUlt } from '../../util/InputValidate';
import { API_BASE_URL } from '@config';
import axios from 'axios';
import useStyles from 'app/cluster-styles/useStyles';
import { formatZoneName, getZoneLabel } from '../util';
import { getClusterSettings } from 'app/main/settings/store/actions';
import { CLUSTER_STATES, DisabledFormWrapper } from 'app/main/util/clusterUtils';
import { RESOURCE_MANAGER, IMAGE_TYPE, IMAGE_MODE } from '../../util/enums';
import { min } from 'lodash';
import StorageConfigurationSection from '../components/StorageConfigurationSection';
import OwnerSelectionCard from 'app/shared-components/OwnerSelectionCard';
import GlobalProvisionScriptsPreview from '../components/GlobalProvisionScriptsPreview';
import ClusterApplicationsSection from '../components/ClusterApplicationsSection';
import useInstanceAvailability from '../hooks/useInstanceAvailability';
import { 
    ZoneAvailabilityIndicator, 
    ZoneMenuItemContent, 
    InstanceAvailabilityBanner 
} from '../components/ZoneAvailabilityComponents';



const efaInstanceTypes = [
    "m5dn.24xlarge", "m5dn.metal", "m5n.24xlarge", "m5n.metal", "m5zn.12xlarge", "m5zn.metal", "m6a.48xlarge", "m6a.metal", "m6i.32xlarge",
    "m6i.metal", "m6id.32xlarge", "m6id.metal", "m6idn.32xlarge", "m6idn.metal", "m6in.32xlarge", "m6in.metal", "m7g.16xlarge", "m7g.metal",
    "c5n.9xlarge", "c5n.18xlarge", "c5n.metal", "c6a.48xlarge", "c6a.metal", "c6gn.16xlarge", "c6i.32xlarge", "c6i.metal", "c6id.32xlarge",
    "c6id.metal", "c6in.32xlarge", "c6in.metal", "c7g.16xlarge", "c7g.metal", "c7gn.16xlarge", "hpc6a.48xlarge", "hpc7g.4xlarge", "hpc7g.8xlarge",
    "hpc7g.16xlarge", "hpc6id.32xlarge", "r5dn.24xlarge", "r5dn.metal", "r5n.24xlarge", "r5n.metal", "r6a.48xlarge", "r6a.metal", "r6i.32xlarge",
    "r6i.metal", "r6idn.32xlarge", "r6idn.metal", "r6in.32xlarge", "r6in.metal", "r6id.32xlarge", "r6id.metal", "r7g.16xlarge", "r7g.metal",
    "x2idn.32xlarge", "x2idn.metal", "x2iedn.32xlarge", "x2iedn.metal", "x2iezn.12xlarge", "x2iezn.metal", "i3en.12xlarge", "i3en.24xlarge",
    "i3en.metal", "i4g.16xlarge", "i4i.32xlarge", "i4i.metal", "im4gn.16xlarge", "dl1.24xlarge", "g4dn.8xlarge", "g4dn.12xlarge", "g4dn.16xlarge",
    "g4dn.metal", "g5.8xlarge", "g5.12xlarge", "g5.16xlarge", "g5.24xlarge", "g5.48xlarge", "g6.8xlarge", "g6.12xlarge", "g6.16xlarge",
    "g6.24xlarge", "g6.48xlarge", "g6e.8xlarge", "g6e.12xlarge", "g6e.16xlarge", "g6e.24xlarge", "g6e.48xlarge", "inf1.24xlarge", "p3dn.24xlarge",
    "p4d.24xlarge", "p4de.24xlarge", "p5.48xlarge", "trn1.32xlarge", "trn1n.32xlarge", "vt1.24xlarge", "c7gn.12xlarge"
];

const AwsCluster = props => {
    // initialize
    const dispatch = useDispatch();
    const classes = useStyles(props);
    const formRef = useRef(null);
    const pkgRef = useRef(null);

    // connect to Redux
    const clusterSettings = useSelector(({ settings }) => settings.settings.clusterSettings);
	const cluster = useSelector(({ clusters }) => clusters.cluster.cluster);
    const clustersArr = useSelector(({ clusters }) => clusters.cluster.list);
    const error = useSelector(({ clusters }) => clusters.cluster.error);
    const providers = useSelector(({ providers }) => providers.providers.list);
    const loading = useSelector(({ fuse }) => fuse.settings.loading);
    const credentials = useSelector(({ credentials }) => credentials.credential.list);
    const supportedOSs = useSelector(({ clusters }) => clusters.cluster.os_types);
    const selectedMarketStack = useSelector(({ marketStack }) => marketStack.marketStack.stack);
    const marketplaceData = useSelector(({ marketStack }) => marketStack.marketStack.list);
    const stacks = useSelector(({ stacks }) => stacks.stack.list);
    const storageProviders = useSelector(({ clusters }) => (clusters && clusters.cluster && clusters.cluster.storageProviders) || []);
    const providerPolicies = useSelector(({ clusters }) => (clusters && clusters.cluster && clusters.cluster.providerPolicies) || {});
    const currentUser = useSelector(({ auth }) => auth.user);
    const globalProvisionPreview = useSelector(({ globalProvision }) => globalProvision?.preview);

    // local state
    const [activePopover, setActivePopover] = useState(null);
    const [isFormValid, setIsFormValid] = useState(false);
    const [zones, setZones] = useState([]);
    const [regions, setRegions] = useState([]);
    const [nodeInstanceSizes, setNodeInstanceSizes] = useState(null);
    const [serverInstanceSizes, setServerInstanceSizes] = useState([]);
    const [filteredCredentials, setFilteredCredentials] = useState([]);
    const [deletedPkgs, setDeletedPkgs] = useState([]);
    const [cost, setCost] = useState(0);
    const [providerVolsize, setProviderVolsize] = useState({ min: 10, max: 1000 })
    const [prefixError, setPrefixError] = useState("");
    const [nodePrefixErrors, setNodePrefixErrors] = useState([]);
    const [clusterNames, setClusterNames] = useState(null)
    const [selectedRegionId, setSelectedRegionId] = useState(null)
    const [saveAttempted, setSaveAttempted] = useState(false);
    const [selectedOwner, setSelectedOwner] = useState('');
    const [enableNodeInternetAccess, setEnableNodeInternetAccess] = useState(false);
    const [enableCapacityReservation, setEnableCapacityReservation] = useState(false);
    const [capacityReservationAutoExpire, setCapacityReservationAutoExpire] = useState(true);
    const [capacityReservationExpireHours, setCapacityReservationExpireHours] = useState(1);

    //this is for the prefix form
    const groupNodePrefixRefs = useRef([]);
    const textFieldRef = useRef(null);
    const [groupNodeInputValues, setGroupNodeInputValues] = useState({});
    const [inputValue, setInputValue] = useState('');
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);
    const [advanced, setAdvanced] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    //quotas
    const [usedIntances, setUsedIntances] = useState(0);
    const [usedNetwork, setUsedNetwork] = useState(0);
    const [usedCpus, setUsedCpus] = useState(0);
    const [limitIntances, setLimitIntances] = useState(9999999);
    const [limitNetwork, setLimitNetwork] = useState(9999999);
    const [limitCpus, setLimitCpus] = useState(9999999);

    // custom hook
    const { form, handleChange, setForm } = useForm(props.oldForm || null);

    //General Marketplace information:
    const market_id_value = selectedMarketStack?.id
    const marketId = form?.info?.market_id ?? market_id_value
    const isMarketStack = Boolean(selectedMarketStack)
    // Fix: Find the market stack in the array by its ID instead of accessing by index
    const currentMarketStack = marketplaceData?.find(item => item.id === marketId) || selectedMarketStack

    //Marketplace header information
    const marketName = currentMarketStack?.name
    const marketVersion = currentMarketStack?.version
    const title = currentMarketStack ? (marketName + ' ' + marketVersion) : form?.name || 'New Cluster'
    const imageSrc = currentMarketStack?.logo
        ? `assets/images/logos/${currentMarketStack?.logo}`
        : `assets/images/providers/aws.png`;

    //Marketplace form information - Add null checks and fallbacks
    const hasMarketplaceConfig = Boolean(currentMarketStack?.config)
    const hasMarketplaceImages = Boolean(hasMarketplaceConfig && currentMarketStack?.config?.marketplace_images?.e4s)
    const marketplaceImages = hasMarketplaceImages ? currentMarketStack.config.marketplace_images.e4s : null;
    const marketplaceOSTypes = hasMarketplaceConfig ? currentMarketStack.config.os_types : null;
    const marketplaceInstanceIds = hasMarketplaceConfig ? currentMarketStack.config.instance_type : null;
    const marketplaceComputeIds = hasMarketplaceConfig ? currentMarketStack.config.computeNodeSize : null;
    const marketplaceRegionIds = marketplaceImages ? Object.keys(marketplaceImages) : [];
    const marketplaceAMIIds = hasMarketplaceImages && selectedRegionId ? marketplaceImages[selectedRegionId] : null;
    const marketplaceManager = hasMarketplaceConfig ? currentMarketStack.config.resource_manager : null;

    // Marketplace app profile flags (data-driven behavior)
    const marketplaceSkipSubscription = hasMarketplaceConfig && currentMarketStack.config.skip_subscription === true;
    const marketplaceHideProvisionScript = hasMarketplaceConfig && currentMarketStack.config.hide_provision_script === true;
    const marketplaceAllowImageSelection = hasMarketplaceConfig && currentMarketStack.config.allow_image_selection === true;
    const marketplaceDisableGlobalScripts = hasMarketplaceConfig && currentMarketStack.config.disable_global_scripts === true;

	const [isVncTokenAuthentication, setIsVncTokenAuthentication] = useState(false);
    const [isVncRemoteClient, setIsVncRemoteClient] = useState(false);
	const [disableInputs, setDisableInputs] = useState(false);
    const [isScriptOpen, setScriptOpen] = useState(false);
    
    // Delete confirmation dialog state
    const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
    const [nodeGroupToDelete, setNodeGroupToDelete] = useState(null);

    const [headNodeSearch, setHeadNodeSearch] = useState('');
    const [headNodeDropdownOpen, setHeadNodeDropdownOpen] = useState(false);
    const [filteredServerInstances, setFilteredServerInstances] = useState([]);
    const headNodeInputRef = useRef(null);

    const [nodeSearchValues, setNodeSearchValues] = useState({});
    const [nodeDropdownOpen, setNodeDropdownOpen] = useState({});
    const [filteredNodeInstances, setFilteredNodeInstances] = useState([]);
    const nodeInputRefs = useRef({});

    const [serverImageType, setServerImageType] = useState(IMAGE_TYPE.HEIDI_STACK);
    const [nodeImageTypes, setNodeImageTypes] = useState({});
    const [imageMode, setImageMode] = useState(IMAGE_MODE.MULTI_IMAGE);

    // Storage configuration state - for volume management
    const [availableStorageConfigs, setAvailableStorageConfigs] = useState([]);
    const [newlyAddedNodeGroups, setNewlyAddedNodeGroups] = useState(new Set());
    const nodeAnimationTimeouts = useRef(new Map());
    const [storageConfigValidation, setStorageConfigValidation] = useState({ isValid: true, errors: [] });

    // Volume selection dropdown state
    const [volumeDropdownOpen, setVolumeDropdownOpen] = useState({});
    const volumeDropdownAnchorEl = useRef({});

    // Head node volume selection dropdown state
    const [headNodeVolumeDropdownOpen, setHeadNodeVolumeDropdownOpen] = useState(false);
    const headNodeVolumeDropdownAnchorEl = useRef(null);

    // Performance Data Sharing info popover state
    const [pdsInfoPopoverAnchorEl, setPdsInfoPopoverAnchorEl] = useState(null);
    const pdsInfoPopoverOpen = Boolean(pdsInfoPopoverAnchorEl);

    // Head node volume details dialog state (to mirror compute node behavior)
    const [headDialogOpen, setHeadDialogOpen] = useState(false);
    const [headSelectedVolume, setHeadSelectedVolume] = useState(null);
    const [headSelectedStorageConfig, setHeadSelectedStorageConfig] = useState(null);
    const [headIsEditable, setHeadIsEditable] = useState(false);

    // Global provision scripts state (Feature 002 enhancement)
    const [excludedGlobalScripts, setExcludedGlobalScripts] = useState([]);

    // Cluster applications state (Feature: cluster-apps)
    const [clusterApplications, setClusterApplications] = useState([]);

    // Instance availability checking hook - grays out zones where selected instances are not available
    // Collect all compute node instance types from form
    const computeNodeInstanceTypes = React.useMemo(() => {
        if (!form || !form.data || !form.data.node || !form.data.node.group) {
            return [];
        }
        return form.data.node.group
            .map(group => group.instance_id)
            .filter(Boolean);
    }, [form && form.data && form.data.node && form.data.node.group]);

    const {
        zoneAvailability,
        isZoneAvailable,
        getMissingInstances,
        isLoading: isAvailabilityLoading,
        error: availabilityError,
        unableToVerify
    } = useInstanceAvailability({
        provider: 'aws',
        credentialId: form && form.credential_id,
        region: form && form.data && form.data.network && form.data.network.region_id,
        headNodeInstance: form && form.data && form.data.server && form.data.server.instance_id,
        computeNodeInstances: computeNodeInstanceTypes,
        enabled: Boolean(form && form.credential_id && form.data && form.data.network && form.data.network.region_id)
    });

    useEffect(() => {
        if (
            isMarketStack &&
            marketplaceManager &&
            form?.data &&
            form.data.manager !== marketplaceManager
        ) {
            setForm(prevForm => {
                if (!prevForm || !prevForm.data) return prevForm;
                return {
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        manager: marketplaceManager
                    }
                };
            });
        }
    }, [isMarketStack, marketplaceManager, form?.data?.manager, setForm]);    

	useEffect(() => {
		if(props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED) {
			setDisableInputs(true);
		}
	}, [props, form])

    // Separate state for script management - only disable upload/delete, not view
    const [disableScriptModification, setDisableScriptModification] = useState(false);
    
    useEffect(() => {
        if(props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED) {
            setDisableScriptModification(true);
        }
    }, [props, form])

    useEffect(() => {
        const names = clustersArr.map(cluster => cluster.name);
        setClusterNames(names);
    }, [clustersArr, setClusterNames]);

    useEffect(() => {
        dispatch(StackActions.getStacks());
		dispatch(getClusterSettings());
		dispatch(getStorageProviders());
    }, [dispatch]);
    useEffect(() => {
        dispatch(MarketActions.getMarketplaceStacks(marketplaceData))
    }, [dispatch, marketplaceData])

    // Auto-activate advanced mode only when editing marketplace clusters (not on new/launch)
    useEffect(() => {
        if (props.type === 'edit' && (currentMarketStack || form?.info?.isMarketplace)) {
            setAdvanced(true);
        }
    }, [props.type, currentMarketStack, form?.info?.isMarketplace]);

    useEffect(() => {
        const setVncValues = () => {
            if (form && form.info) {
                setIsVncTokenAuthentication(form.info.vncTokenAuthentication !== undefined ? form.info.vncTokenAuthentication : clusterSettings?.vncTokenAuthentication);
                setIsVncRemoteClient(form.info.vncRemoteClient !== undefined ? form.info.vncRemoteClient : clusterSettings?.vncRemoteClient);
            } else if (clusterSettings) {
                setIsVncTokenAuthentication(clusterSettings.vncTokenAuthentication);
                setIsVncRemoteClient(clusterSettings.vncRemoteClient);
            }
        };

        setVncValues();
    }, [form, clusterSettings]);

    // Set fast capacity validation default for new clusters
    useEffect(() => {
        if (props.type === 'new' && clusterSettings?.fastCapacityValidationDefault !== undefined) {
            setEnableCapacityReservation(clusterSettings.fastCapacityValidationDefault);
        }
    }, [props.type, clusterSettings]);

    // Load excluded global scripts when editing an existing cluster (Feature 002 enhancement)
    useEffect(() => {
        if (props.type === 'edit' && form) {
            // Check both locations - data.excludedGlobalScripts and root level excludedGlobalScripts
            const excluded = form.data?.excludedGlobalScripts || form.excludedGlobalScripts;
            if (excluded && excluded.length > 0) {
                setExcludedGlobalScripts(excluded);
            }
        }
    }, [props.type, form?.data?.excludedGlobalScripts, form?.excludedGlobalScripts]);

    // Auto-exclude ALL global provision scripts when marketplace config has disable_global_scripts
    useEffect(() => {
        if (marketplaceDisableGlobalScripts && globalProvisionPreview?.configs?.length > 0) {
            const allScriptIds = [];
            globalProvisionPreview.configs.forEach(function(config) {
                if (config.scripts) {
                    config.scripts.forEach(function(script) {
                        allScriptIds.push(config._id + '-' + script._id);
                    });
                }
            });
            if (allScriptIds.length > 0) {
                setExcludedGlobalScripts(allScriptIds);
            }
        }
    }, [marketplaceDisableGlobalScripts, globalProvisionPreview?.configs]);

    // Load cluster applications when editing or from marketplace pre-populated data
    useEffect(() => {
        if (form) {
            const apps = form.applications;
            if (apps && apps.length > 0) {
                setClusterApplications(apps);
            }
        }
    }, [props.type, form?.applications]);
    
    const setClusterInfo = (e) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, moab: { ...form.data.moab, [e.target.name]: e.target.value } }));
    }

    // lifecycle hook functions
    useEffect(() => {
        if (props.type === 'new') {
            selectedMarketStack ?
                dispatch(Actions.newMarketCluster(selectedMarketStack)) :
                dispatch(Actions.newCluster());
        }
    }, [props.type, selectedMarketStack, dispatch]);

    useEffect(() => {
        if (form?.data?.network?.region_id) {
            let costNodesTotal = 0;
            let costNode = 0;
            const sps = providers.filter(p => p.id === "aws");
            
            // Safety check: ensure AWS provider and instanceSizes exist
            if (!sps[0] || !sps[0].instanceSizes) {
                return;
            }
            
            const headNode = sps[0].instanceSizes.filter(r => r.instance_id === form.data.server.instance_id);
            const costHeadNode = headNode[0]?.cost?.cost_region[form.data.network.region_id];

            form.data.node.group.map(val => {
                const node = sps[0].instanceSizes.filter(r => r.instance_id === val.instance_id);
                const costNodes = node[0]?.cost?.cost_region[form.data.network.region_id];
                if (costNodes) {
                    costNode = costNodes * val.count;
                    costNodesTotal = costNodesTotal + costNode;
                }
                return 0;
            });
            setCost(costNodesTotal + costHeadNode);
        }
    }, [form, providers]);

    useEffect(() => {
        const err = error || props.error;
        if (err && err.type === 'form') {
            const name = { name: err.message };
            formRef.current &&
                formRef.current.updateInputsWithError({
                    ...name
                });
            disableButton();
        }
    }, [error, props.error]);
    
    useEffect(() => {
        // Reset saveAttempted flag when there are no errors (successful submission)
        if (!error && !props.error && saveAttempted) {
            setSaveAttempted(false);
        }
    }, [error, props.error, saveAttempted]);
    
    useEffect(() => {
        setInputValue(form?.info?.prefix);
    }, [form]);
    useEffect(() => {
        if ((cluster && !form) || (cluster && form && cluster.id !== form.id)) {
            // Ensure the provision object with script field is initialized
            const clusterWithProvision = {
                ...cluster,
                data: {
                    ...cluster.data,
                    provision: {
                        ...cluster.data.provision || {},
                        script: cluster.data?.provision?.script || ''
                    },
                    network: {
                        ...cluster.data.network || {},
                        enable_node_internet_access: cluster.data.network?.enable_node_internet_access ?? false,
                        enable_capacity_reservation: cluster.data.network?.enable_capacity_reservation ?? false,
                        capacity_reservation_auto_expire: cluster.data.network?.capacity_reservation_auto_expire ?? true,
                        capacity_reservation_expire_hours: cluster.data.network?.capacity_reservation_expire_hours ?? 1
                    }
                }
            };
            setForm(clusterWithProvision);
            setEnableNodeInternetAccess(cluster.data.network?.enable_node_internet_access ?? false);
            setEnableCapacityReservation(cluster.data.network?.enable_capacity_reservation ?? false);
            setCapacityReservationAutoExpire(cluster.data.network?.capacity_reservation_auto_expire ?? true);
            setCapacityReservationExpireHours(cluster.data.network?.capacity_reservation_expire_hours ?? 1);
        }
    }, [form, cluster, setForm]);
    useEffect(() => {
        if (form && form.data?.network?.region_id) {
            providers.map(
                p =>
                    p.id === "aws" &&
                    p.regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones))
            );
        }
    }, [providers, form]);

    //Set instance sizes and node sizes here
    useEffect(() => {
        if (
            providers &&
            form &&
            (!nodeInstanceSizes || !serverInstanceSizes || !filteredCredentials || !regions || !zones)
        ) {
            const P = providers.find(provider => provider.id === "aws");
            const InstSizes = P.instanceSizes;
            const Regions = P.regions;
            if (props.type !== 'new') {
                if (InstSizes.filter(s => s.instance_id === form.data.server.instance_id).length === 0) {
                    InstSizes.push({ instance_id: form.data.server.instance_id, name: form.data.server.instance_id, cores: 0 });
                }
                if (Regions.filter(r => r.region_id === form.data.network.region_id).length === 0) {
                    Regions.push({
                        region_id: form.data.network.region_id,
                        name: form.data.network.region_id,
                        zones: [form.data.network.zone_id]
                    });
                }

                for (const gs of form.data.node.group) {
                    let contains = false;
                    for (const s of InstSizes) {
                        if (s.instance_id === gs.instance_id) {
                            contains = true;
                        }
                    }

                    if (!contains) {
                        InstSizes.push({ instance_id: gs.instance_id, name: gs.instance_id, cores: 0 });
                    }
                }
            }
            const C = credentials.filter(cred => cred.provider === "aws");
            setNodeInstanceSizes(InstSizes);
            setServerInstanceSizes(InstSizes);
            setFilteredCredentials(C);
            setRegions(Regions);
            if (form.data.network.region_id) {
                Regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones));
            }
        }
    }, [
        providers,
        props,
        form,
        credentials,
        nodeInstanceSizes,
        serverInstanceSizes,
        filteredCredentials,
        regions,
        zones
    ]);

    //zone specific conditionals and variables:
    const isZoneDisabled = zones.length === 0;

    useEffect(() => {
        // Function to set the initial values for the node group and server instance
        const setInitialValues = () => {
            let initialNodeInstanceId = nodeInstanceSizes[0].instance_id;
            let initialServerInstanceId = serverInstanceSizes[0].instance_id;

            if (currentMarketStack) {
                initialNodeInstanceId = currentMarketStack.config?.computeNodeSize?.[0] ?? initialNodeInstanceId;
                initialServerInstanceId = currentMarketStack.config?.instance_type?.[0] ?? initialServerInstanceId;
            }
            form.data.node.group.forEach(groupItem => {
                if (!groupItem.instance_id) {
                    groupItem.instance_id = initialNodeInstanceId
                }
            })
            if (!form.data.server.instance_id) form.data.server.instance_id = initialServerInstanceId
            return { ...form }
        };
        if (form && form.data.node.group.length === 1 && !form.data.node.group[0].instance_id && nodeInstanceSizes) {
            setForm(setInitialValues())
        }
    }, [form, currentMarketStack, nodeInstanceSizes, serverInstanceSizes, setForm]);

    // Initialize and restore storage-managed groups on form load using database fields
    useEffect(() => {
        if (form && form.data && form.data.node && form.data.storageConfigurations) {
            const currentGroups = [...form.data.node.group];
            let hasChanges = false;
            
            const updatedGroups = currentGroups.map(group => {
                // If group has storageReference or nodeType, it's already properly identified
                if (group.storageReference && group.nodeType && group.nodeType === 'media') {
                    // Ensure UI flags are set for backward compatibility
                    const updatedGroup = {
                        ...group,
                        isMediaGroup: group.nodeType === 'media'
                    };
                    
                    if (!group.isMediaGroup) {
                        hasChanges = true;
                    }
                    
                    return updatedGroup;
                }
                
                // Legacy support: Try to identify storage-managed groups without proper database fields
                // Check for media groups - identify by matching mediaType with instance_id
                const matchingMediaConfig = form.data.storageConfigurations.find(config => 
                    config.mediaType === group.instance_id &&
                    ((group.group_node_prefix_label || '').includes('Media Storage') ||
                     (group.group_node_prefix === config.stackName || (!group.group_node_prefix && !config.stackName)))
                );
                
                if (matchingMediaConfig) {
                    hasChanges = true;
                    // Match the database storage reference pattern
                    const storageReference = matchingMediaConfig.id ? 
                        `media-${matchingMediaConfig.id}` : 
                        `media-${matchingMediaConfig.name}`;
                    return {
                        ...group,
                        storageReference: storageReference, // Set database field
                        nodeType: 'media', // Set database field
                        isMediaGroup: true // UI compatibility flag
                    };
                }
                
                // Regular group - ensure it has proper nodeType
                if (!group.nodeType) {
                    hasChanges = true;
                    return {
                        ...group,
                        nodeType: 'regular',
                        isMediaGroup: false
                    };
                }
                
                return group;
            });
            
            if (hasChanges) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        node: {
                            ...prevForm.data.node,
                            group: updatedGroups
                        }
                    }
                }));
            }
        }
    }, [form?.data?.storageConfigurations, form?.data?.node?.group?.length]);

    const setNodeObj = useCallback(({ name, value }) => {
        setForm(prevForm => {
            return {
                ...prevForm,
                data: {
                    ...prevForm.data,
                    node: {
                        ...prevForm.data.node,
                        [name]: value
                    }
                }
            };
        });
    }, [setForm]);

    useEffect(() => {
        if (form && form.data.server.disk_type !== form.data.node.disk_type) {
            setNodeObj({ name: 'disk_type', value: form.data.server.disk_type });
        }
    }, [form, setNodeObj]);
    // These are for the PopOver, the validation has been moved to ./InputValidate.js
    //node volumen prop
    useEffect(() => {
        setProviderVolsize(setinstancesVol("aws", isMarketStack)); //set Volume limit depending on provider
        dispatch(Actions.provider_os_types("aws"))
    }, [dispatch, isMarketStack]);

    // Auto-select OS type when marketplace app restricts supported OS types
    useEffect(() => {
        if (marketplaceOSTypes && supportedOSs && supportedOSs.length > 0 && form) {
            const allowedOSs = supportedOSs.filter(os => marketplaceOSTypes.includes(os));
            if (allowedOSs.length > 0 && !allowedOSs.includes(form.info['os-type'])) {
                setInfoObj({ name: 'os-type', value: allowedOSs[0] });
            }
        }
    }, [marketplaceOSTypes, supportedOSs]);

    //node volumen prop
    useEffect(() => {
        if (form?.data.network.region_id) {
            const sps = providers.filter(p => p.id === "aws");
            const region = sps[0].regions.filter(r => r.region_id === form.data.network.region_id);
            const zone = region[0]?.zones?.filter(
                r => r.zone_id === form.data.network.availability_domain || r.zone_id === form.data.network.zone_id
            );

            const clustersInUse = clustersArr.filter(c => c.info.state !== 'down' && c.provider === "aws");
            let intances = clustersInUse.length;
            let network = clustersInUse.length;
            let cpus = 0;

            clustersInUse.forEach(c => {
                const fp = providers.filter(p => p.id === c.provider);
                //nodes used
                c.data.node.group.forEach(i => {
                    intances = parseInt(intances) + parseInt(i.count);
                    const ccores = fp[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                    cpus = cpus + parseInt(ccores[0]?.cores) * i.count;
                });
                //server used
                const scores = fp[0].instanceSizes.filter(co => co.instance_id === c.data.server.instance_id);
                cpus = cpus + parseInt(scores[0].cores);
            });

            //server edict
            const ecores = sps[0].instanceSizes.filter(co => co.instance_id === form.data.server.instance_id);
            network++;
            intances++;
            cpus = cpus + parseInt(ecores[0].cores);

            form.data.node.group.forEach(i => {
                intances = parseInt(intances) + parseInt(i.count);
                const eccores = sps[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                if (eccores[0]?.cores) cpus = cpus + parseInt(eccores[0].cores) * i.count;
            });

            setUsedCpus(cpus);
            setUsedIntances(intances);
            setUsedNetwork(network);

            zone?.[0]?.quotas?.cpus && setLimitIntances(zone[0]?.quotas?.cpus);
            zone?.[0]?.quotas?.intance && setLimitCpus(zone[0]?.quotas?.intance);
            zone?.[0]?.quotas?.network && setLimitNetwork(zone[0]?.quotas?.network);
        }
    }, [form, providers, clustersArr]);

    // Initialize selectedOwner when editing existing cluster
    useEffect(() => {
        if (props.type === 'edit' && form?.user && form.user.length > 0) {
            setSelectedOwner(form.user[0]);
        }
    }, [props.type, form?.user]);

    const isCompatibleForEFA = (instance_id) => {
        // First check if the instance has the EFA_support property
        const instance = nodeInstanceSizes?.find(instance => instance.instance_id === instance_id);
        if (instance && instance.EFA_support === true) {
            return true;
        }
        
        // Fallback to the hardcoded list for backward compatibility
        return efaInstanceTypes.includes(instance_id);
    };

    // helper functions
    const getDefaultOsType = () => {
        // If marketplace restricts OS types, prioritize the marketplace OS
        if (marketplaceOSTypes && supportedOSs) {
            const allowedOSs = supportedOSs.filter(os => marketplaceOSTypes.includes(os));
            if (allowedOSs.length > 0) {
                if (form.info['os-type'] && allowedOSs.includes(form.info['os-type'])) {
                    return form.info['os-type'];
                }
                return allowedOSs[0];
            }
        }
        if (supportedOSs.includes(form.info['os-type'])) {
            return form.info['os-type'];
        }
        return supportedOSs[0] || '';
    };

    const handleClose = useCallback(() => {
        dispatch(ActionsDialog.closeDialog())
        dispatch(MarketActions.clearStack())
    }, [dispatch]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleClose]);

    // Cleanup animation timeouts on component unmount
    useEffect(() => {
        return () => {
            // Clear all animation timeouts
            nodeAnimationTimeouts.current.forEach(timeoutId => clearTimeout(timeoutId));
            nodeAnimationTimeouts.current.clear();
        };
    }, []);

    // Reconstruct volume assignments when form is loaded - updated for new architecture
    useEffect(() => {
        if (form && form.data && form.data.node && form.data.node.group) {
            let hasChanges = false;
            const updatedForm = { ...form };
            
            // Helper function to get policy values based on policy name
            const getPolicyValues = (policyName, storageConfig) => {
                if (policyName === 'custom' || !policyName) {
                    // Use values from storageConfig for custom policies
                    return {
                        readIops: storageConfig?.performanceConfig?.readIops,
                        readBandwidth: storageConfig?.performanceConfig?.readBandwidth,
                        writeIops: storageConfig?.performanceConfig?.writeIops,
                        writeBandwidth: storageConfig?.performanceConfig?.writeBandwidth,
                        latencyRead: storageConfig?.performanceConfig?.latencyRead,
                        latencyWrite: storageConfig?.performanceConfig?.latencyWrite,
                        localZoneRead: storageConfig?.advancedConfig?.localZoneRead,
                        capacityOptimization: storageConfig?.capacityConfig?.optimization,
                        capacityReservation: storageConfig?.capacityConfig?.reservation,
                        encryption: storageConfig?.advancedConfig?.encryption,
                        resiliencyMedia: storageConfig?.resiliencyConfig?.mediaFailures || 0,
                        resiliencyNode: storageConfig?.resiliencyConfig?.nodeFailures || 0,
                        resiliencyZone: storageConfig?.resiliencyConfig?.zoneFailures || 0
                    };
                } else {
                    // Look up predefined policy values
                    const storageProvider = storageProviders.find(provider => provider._id === storageConfig?.providerId);
                    let predefinedPolicy = null;
                    
                    if (storageProvider && storageProvider.policies) {
                        predefinedPolicy = storageProvider.policies.find(policy => 
                            policy.name === policyName || 
                            (storageConfig.policyId && policy.id === storageConfig.policyId)
                        );
                    }
                    
                    if (predefinedPolicy) {
                        return {
                            readIops: predefinedPolicy.iopsread,
                            readBandwidth: predefinedPolicy.bandwidthread,
                            writeIops: predefinedPolicy.iopswrite,
                            writeBandwidth: predefinedPolicy.bandwidthwrite,
                            latencyRead: predefinedPolicy.latencyread,
                            latencyWrite: predefinedPolicy.latencywrite,
                            localZoneRead: predefinedPolicy.localzoneread,
                            capacityOptimization: predefinedPolicy.capacityoptimization,
                            capacityReservation: predefinedPolicy.capacityreservation,
                            encryption: predefinedPolicy.encryption,
                            resiliencyMedia: predefinedPolicy.resiliencymedia,
                            resiliencyNode: predefinedPolicy.resiliencynode,
                            resiliencyZone: predefinedPolicy.resiliencyzone
                        };
                    } else {
                        // Fallback to storageConfig values if policy not found
                        return {
                            readIops: storageConfig?.performanceConfig?.readIops,
                            readBandwidth: storageConfig?.performanceConfig?.readBandwidth,
                            writeIops: storageConfig?.performanceConfig?.writeIops,
                            writeBandwidth: storageConfig?.performanceConfig?.writeBandwidth,
                            latencyRead: storageConfig?.performanceConfig?.latencyRead,
                            latencyWrite: storageConfig?.performanceConfig?.latencyWrite,
                            localZoneRead: storageConfig?.advancedConfig?.localZoneRead,
                            capacityOptimization: storageConfig?.capacityConfig?.optimization,
                            capacityReservation: storageConfig?.capacityConfig?.reservation,
                            encryption: storageConfig?.advancedConfig?.encryption,
                            resiliencyMedia: storageConfig?.resiliencyConfig?.mediaFailures || 0,
                            resiliencyNode: storageConfig?.resiliencyConfig?.nodeFailures || 0,
                            resiliencyZone: storageConfig?.resiliencyConfig?.zoneFailures || 0
                        };
                    }
                }
            };
            
            // Process each node group to ensure attachedVolumes are properly structured
            updatedForm.data.node.group.forEach((group, groupIndex) => {
                // Initialize attachedVolumes if it doesn't exist but old volumes field exists
                if (!group.attachedVolumes && group.volumes) {
                    group.attachedVolumes = group.volumes.map(vol => {
                        // Find the storage config for this volume to get missing properties
                        const storageConfig = availableStorageConfigs.find(config => config.id === vol.storageConfigId);
                        const policyName = vol.policyName || storageConfig?.volumezSettings?.policyName || storageConfig?.policyName || 'custom';
                        const policyValues = getPolicyValues(policyName, storageConfig);
                        
                        return {
                            id: vol.id || `migrated-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                            storageConfigId: vol.storageConfigId,
                            mountPath: vol.mountPath,
                            size: vol.size,
                            performanceOverrides: {
                                readIops: policyValues.readIops,
                                readBandwidth: policyValues.readBandwidth,
                                writeIops: policyValues.writeIops,
                                writeBandwidth: policyValues.writeBandwidth,
                                latencyRead: policyValues.latencyRead,
                                latencyWrite: policyValues.latencyWrite
                            },
                            policyName: policyName,
                            policyId: vol.policyId || storageConfig?.policyId,
                            resiliencyConfig: {
                                mediaFailures: policyValues.resiliencyMedia,
                                nodeFailures: policyValues.resiliencyNode,
                                zoneFailures: policyValues.resiliencyZone
                            },
                            advancedConfig: {
                                localZoneRead: policyValues.localZoneRead,
                                encryption: policyValues.encryption
                            },
                            capacityConfig: {
                                optimization: policyValues.capacityOptimization,
                                reservation: policyValues.capacityReservation
                            }
                        };
                    });
                    
                    // Remove old volumes field
                    delete group.volumes;
                    hasChanges = true;
                }
                
                // Update existing attachedVolumes that may be missing the new properties
                if (group.attachedVolumes && group.attachedVolumes.length > 0) {
                    group.attachedVolumes.forEach(vol => {
                        // Find the storage config for this volume
                        const storageConfig = availableStorageConfigs.find(config => config.id === vol.storageConfigId);
                        
                        // Add missing policyName if not present
                        if (!vol.policyName && storageConfig) {
                            vol.policyName = storageConfig.volumezSettings?.policyName || storageConfig.policyName || 'custom';
                            hasChanges = true;
                        }
                        
                        // Update policy values based on policy type 
                        if (vol.policyName && storageConfig) {
                            const policyValues = getPolicyValues(vol.policyName, storageConfig);
                            
                            // Update performance overrides with correct policy values
                            if (!vol.performanceOverrides || Object.keys(vol.performanceOverrides).length === 0) {
                                vol.performanceOverrides = {
                                    readIops: policyValues.readIops,
                                    readBandwidth: policyValues.readBandwidth,
                                    writeIops: policyValues.writeIops,
                                    writeBandwidth: policyValues.writeBandwidth,
                                    latencyRead: policyValues.latencyRead,
                                    latencyWrite: policyValues.latencyWrite
                                };
                                hasChanges = true;
                            }
                            
                            // Update resiliency config with correct policy values
                            if (!vol.resiliencyConfig) {
                                vol.resiliencyConfig = {
                                    mediaFailures: policyValues.resiliencyMedia,
                                    nodeFailures: policyValues.resiliencyNode,
                                    zoneFailures: policyValues.resiliencyZone
                                };
                                hasChanges = true;
                            }
                            
                            // Add missing advancedConfig and capacityConfig
                            if (!vol.advancedConfig) {
                                vol.advancedConfig = {
                                    localZoneRead: policyValues.localZoneRead,
                                    encryption: policyValues.encryption
                                };
                                hasChanges = true;
                            }
                            
                            if (!vol.capacityConfig) {
                                vol.capacityConfig = {
                                    optimization: policyValues.capacityOptimization,
                                    reservation: policyValues.capacityReservation
                                };
                                hasChanges = true;
                            }
                        }
                    });
                }
                
                // Ensure attachedVolumes exists even if empty
                if (!group.attachedVolumes) {
                    group.attachedVolumes = [];
                }
            });
            
            // Only update form if there were changes
            if (hasChanges) {
                setForm(updatedForm);
            }
        }
    }, [form?.data?.node?.group, availableStorageConfigs, storageProviders, setForm]);

    const disableButton = () => setIsFormValid(false);

    const enableButton = () => setIsFormValid(true);

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };
    const handleGroupNodeMenuItemClick = (index, selectedPrefix) => {
        setGroupNodeInputValues(prevValues => ({
            ...prevValues,
            [index]: selectedPrefix
        }));
        setNodePrefix(index, selectedPrefix);

        setActiveMenuIndex(null);
    };

    const handleGroupNodeMenuOpen = (index) => {
        setActiveMenuIndex(index);
    };
    const handleDeletePackages = pkg => {
        const filteredPkgs = form.data.packages.filter(p => p !== pkg);
        setDataObj({ name: 'packages', value: filteredPkgs });
        const isInPkgs = form.data.packages.some(p => p === pkg);
        const isInDeletedPkgs = deletedPkgs.some(dp => dp === pkg);
        if (isInPkgs && !isInDeletedPkgs) {
            const delArr = form.data.packages.filter(p => p === pkg);
            setDeletedPkgs([...deletedPkgs, ...delArr]);
        }
    };

    const setDataObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, [name]: value }));
    };

    const setNetworkObj = ({ name, value }) => {
        if (name === 'ami_encrypted') {
            setForm(_.set({ ...form }, 'data', { ...form.data, network: { ...form.data.network, [name]: !form.data.network.ami_encrypted } }));
        } else {
            setForm(_.set({ ...form }, 'data', { ...form.data, network: { ...form.data.network, [name]: value } }));
        }
    };

    const combineSameConfigurationNodes = groups => {
        const seenGroups = {};
        groups.forEach(group => {
            const compositeId = `${group.group_node_prefix_label}-${group.group_node_prefix}-${group.instance_id}-${group.ocpu}-${group.mem}-${group.efa}`;
            if (compositeId in seenGroups)
                seenGroups[compositeId].count = parseInt(seenGroups[compositeId].count) + parseInt(group.count);
            else seenGroups[compositeId] = group;
        });
        const filteredGroups = Object.keys(seenGroups).map(key => seenGroups[key]);
        return filteredGroups;
    };

    const setInstanceId = (i = 0, value) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        if (value !== 'c5n.9xlarge') setEfaForNode(i, false)
        const groups = form.data.node.group;
        groups[i]['instance_id'] = value;
        if (!value.includes('Flex')) {
            setNodeOCPUS(i, 1);
            setNodeMEM(i, 1);
        }
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };
    const setNodePrefix = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setNodePrefixLabel = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix_label'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    }
    
    // Update this useEffect to automatically set group_node_prefix_label
    useEffect(() => {
        if (form?.data?.node?.group) {
            // Auto-set Node Group labels if they don't exist
            const updatedGroups = form.data.node.group.map((group, index) => {
                if (!group.group_node_prefix_label) {
                    group.group_node_prefix_label = `Node Group ${index + 1}`;
                }
                return group;
            });
            
            // Only update if there were changes
            if (updatedGroups.some((group, index) => 
                group.group_node_prefix_label !== form.data.node.group[index].group_node_prefix_label
            )) {
                setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: updatedGroups } }));
            }
            
            // Initialize node image types
            const initialTypes = {};
            updatedGroups.forEach((node, index) => {
                initialTypes[index] = node.image_type || IMAGE_TYPE.HEIDI_STACK;
            });
            setNodeImageTypes(initialTypes);
        }
    }, [form?.data?.node?.group, setForm]);

    const setEfaForNode = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['efa'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setNodeZone = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['zone_id'] = value;
        
        // Check if zones are different and disable EFA if they are
        checkAndDisableEFAForDifferentZones(groups);
        
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const checkAndDisableEFAForDifferentZones = (groups) => {
        // Get all zones (including head node zone and node group zones)
        const headNodeZone = form.data.network.zone_id;
        const nodeZones = groups.map(group => group.zone_id || headNodeZone).filter(Boolean);
        
        // Add head node zone if it exists
        if (headNodeZone) {
            nodeZones.push(headNodeZone);
        }
        
        // Check if there are different zones
        const uniqueZones = [...new Set(nodeZones)];
        const hasDifferentZones = uniqueZones.length > 1;
        
        // If there are different zones, disable EFA for all node groups
        if (hasDifferentZones) {
            groups.forEach(group => {
                if (group.efa) {
                    group.efa = false;
                }
            });
        }
    };

    const areZonesDifferent = () => {
        // Get all zones (including head node zone and node group zones)
        const headNodeZone = form.data.network.zone_id;
        const nodeZones = form.data.node.group.map(group => group.zone_id || headNodeZone).filter(Boolean);
        
        // Add head node zone if it exists
        if (headNodeZone) {
            nodeZones.push(headNodeZone);
        }
        
        // Check if there are different zones
        const uniqueZones = [...new Set(nodeZones)];
        return uniqueZones.length > 1;
    };
    const setNodeMEM = (i, value) => {
        const groups = form.data.node.group;
        groups[i].mem = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setInstanceCount = (i, { name, value }) => {
        const group = form.data.node.group;
        group[i][name] = value;

        const groupFiltered = combineSameConfigurationNodes(group);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setServerObj = ({ name, value }) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        if (name === 'instance_id' && !value.includes('Flex')) {
            form.data.server.ocpus = form.data.server.mem = 1;
            setForm(_.set({ ...form }, 'data', { ...form.data, server: { ...form.data.server, [name]: value } }));
        } else {
            setForm(_.set({ ...form }, 'data', { ...form.data, server: { ...form.data.server, [name]: value } }));
        }
    };

    const setInfoObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'info', { ...form.info, [name]: value }));
    };

    const setNodeOCPUS = (i, value) => {
        const groups = form.data.node.group;
        groups[i].ocpus = value;
    };
    const setPackagesArr = () => {
        const pkg = pkgRef.current.value;
        setForm(_.set({ ...form }, 'data', { ...form.data, packages: [...form.data.packages, pkg] }));
        pkgRef.current.value = null;
    };

    const handleUpload = e => {
        const file = e.target.files[0];
        if (!file) return;

        //reset value to '' so that the same file can be uploaded if removed
        e.target.value = '';

        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
            setForm(
                _.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: reader.result } })
            );
        };
    };
    //Validation functions
    const validationInput = (type, instanceid, currentvalue, ocpus, provider, currentMarketStack) => {
        return validationInputUlt(type, instanceid, currentvalue, ocpus, provider, currentMarketStack);
    };

    const validationMess = (type, instanceid, ocpus, provider, currentMarketStack) => {
        return validationMessUlt(type, instanceid, ocpus, provider, currentMarketStack);
    };

    const handleDeleteScript = () => {
        setForm(_.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: '' } }));
    };

    const addComputeNode = () => {
        if (form.data.node.group.length < 250) {
            // Find a regular node group to use as template, or create a clean default
            const regularGroup = form.data.node.group.find(group => 
                group.nodeType === 'regular' || (!group.nodeType && !group.storageReference)
            );
            
            // In unified mode, use server's image_name as the node prefix and inherit image_type
            const unifiedPrefix = imageMode === IMAGE_MODE.UNIFIED ? form.data.server.image_name : '';
            const unifiedImageType = imageMode === IMAGE_MODE.UNIFIED ? serverImageType : IMAGE_TYPE.HEIDI_STACK;
            
            let initialValues;
            if (regularGroup) {
                // Use regular group as template, but ensure clean properties
                initialValues = {
                    instance_id: regularGroup.instance_id,
                    count: 1,
                    group_node_prefix: unifiedPrefix,
                    group_node_prefix_label: `Node Group ${form.data.node.group.length + 1}`,
                    efa: false,
                    zone_id: form.data.network.zone_id || null, // Default to head node zone
                    ocpus: regularGroup.ocpus || 1,
                    mem: regularGroup.mem || 1,
                    disk_type: regularGroup.disk_type || form.data.server.disk_type || 'gp3',
                    volume_size: regularGroup.volume_size || form.data.node.volume_size || 100,
                    image_type: imageMode === IMAGE_MODE.UNIFIED ? unifiedImageType : (regularGroup.image_type || IMAGE_TYPE.HEIDI_STACK),
                    nodeType: 'regular',
                    // Explicitly exclude storage-related properties
                    storageReference: undefined,
                    isMediaGroup: false,
                    isApplicationGroup: false
                };
            } else {
                // Create a clean default template when no regular groups exist
                initialValues = {
                    instance_id: nodeInstanceSizes?.[0]?.instance_id || 't3.medium',
                    count: 1,
                    group_node_prefix: unifiedPrefix,
                    group_node_prefix_label: `Node Group ${form.data.node.group.length + 1}`,
                    efa: false,
                    zone_id: form.data.network.zone_id || null, // Default to head node zone
                    ocpus: 1,
                    mem: 1,
                    disk_type: form.data.server.disk_type || 'gp3',
                    volume_size: form.data.node.volume_size || 100,
                    image_type: unifiedImageType,
                    nodeType: 'regular',
                    // Explicitly exclude storage-related properties
                    storageReference: undefined,
                    isMediaGroup: false,
                    isApplicationGroup: false
                };
            }
            
            setForm((prevForm) => ({
                ...prevForm, 
                data: { 
                    ...prevForm.data, 
                    node: { 
                        ...prevForm.data.node, 
                        group: [initialValues, ...prevForm.data.node.group] // Add new group at the beginning
                    } 
                }
            }));
            
            // Track newly added node group for animation (use index 0 since we add at beginning)
            const nodeGroupId = `node-0`;
            setNewlyAddedNodeGroups(prev => new Set([...prev, nodeGroupId]));
            
            // Remove from newly added groups after animation completes
            const timeoutId = setTimeout(() => {
                setNewlyAddedNodeGroups(prev => {
                    const updated = new Set(prev);
                    updated.delete(nodeGroupId);
                    return updated;
                });
                nodeAnimationTimeouts.current.delete(nodeGroupId);
            }, 1050); // Match animation duration (30% faster)
            
            nodeAnimationTimeouts.current.set(nodeGroupId, timeoutId);
        }
    }
    const showDeleteConfirmation = (nodeGroupToRemove) => {
        setNodeGroupToDelete(nodeGroupToRemove);
        setConfirmDeleteDialogOpen(true);
    };

    const closeConfirmDeleteDialog = () => {
        setConfirmDeleteDialogOpen(false);
        setNodeGroupToDelete(null);
    };

    const confirmDeleteNodeGroup = () => {
        if (nodeGroupToDelete) {
            removeComputeNode(nodeGroupToDelete);
        }
        closeConfirmDeleteDialog();
    };

    const removeComputeNode = (nodeGroupToRemove) => {
        if (form.data.node.group.length > 1) {
            setForm((prevForm) => {
                // Find the actual index of the node group in the original array
                const actualIndex = prevForm.data.node.group.findIndex(group => {
                    // For storage-managed groups, use storageReference as unique identifier
                    if (nodeGroupToRemove.storageReference && group.storageReference) {
                        return group.storageReference === nodeGroupToRemove.storageReference;
                    }
                    // For regular groups, use a combination of properties since they might not have unique IDs
                    return group === nodeGroupToRemove || 
                           (group.instance_id === nodeGroupToRemove.instance_id && 
                            group.group_node_prefix === nodeGroupToRemove.group_node_prefix &&
                            group.count === nodeGroupToRemove.count &&
                            !group.storageReference && !nodeGroupToRemove.storageReference);
                });
                
                if (actualIndex !== -1) {
                    const group = [...prevForm.data.node.group];
                    group.splice(actualIndex, 1);
                    
                    // Clean up animation state for removed node group
                    const nodeGroupId = `node-${actualIndex}`;
                    setNewlyAddedNodeGroups(prev => {
                        const updated = new Set(prev);
                        updated.delete(nodeGroupId);
                        return updated;
                    });
                    
                    // Clean up animation timeout if it exists
                    const timeoutId = nodeAnimationTimeouts.current.get(nodeGroupId);
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                        nodeAnimationTimeouts.current.delete(nodeGroupId);
                    }
                    
                    return { ...prevForm, data: { ...prevForm.data, node: { ...prevForm.data.node, group } } };
                }
                
                return prevForm; // Return unchanged if node group not found
            });
        }
    }

    // Volume management functions - simplified for VolumeManager component
    const addVolumeToNode = (nodeIndex, storageConfigId) => {
        const storageConfig = availableStorageConfigs.find(config => config.id === storageConfigId);
        if (!storageConfig) return;

        const updatedForm = { ...form };
        const targetNodeGroup = updatedForm.data.node.group[nodeIndex];
        if (!targetNodeGroup) return;

        // Initialize attachedVolumes array if not exists
        if (!targetNodeGroup.attachedVolumes) {
            targetNodeGroup.attachedVolumes = [];
        }

        // Create a new volume attachment using new schema
        const volumeIndex = targetNodeGroup.attachedVolumes.length + 1;
        
        // Determine the volume prefix, with backward compatibility for old mountingPath
        let volumePrefix = storageConfig.volumeConfig?.volumePrefix;
        if (!volumePrefix && storageConfig.mountingPath) {
            const pathParts = storageConfig.mountingPath.split('/');
            const lastPart = pathParts[pathParts.length - 1];
            volumePrefix = lastPart.replace(/-\d+$/, '');
        }
        if (!volumePrefix) {
            volumePrefix = 'storage';
        }
        
        const basePath = storageConfig.volumeConfig?.basePath || '/mnt';
        const dynamicMountPath = `${basePath}/${volumePrefix}-${volumeIndex}`;
        
        // Determine policy name and get policy values
        const policyName = storageConfig.volumezSettings?.policyName || storageConfig.policyName || 'custom';
        let policyValues = {};
        
        if (policyName === 'custom') {
            // For custom policies, use values from storageConfig (current behavior)
            policyValues = {
                readIops: storageConfig.performanceConfig?.readIops,
                readBandwidth: storageConfig.performanceConfig?.readBandwidth,
                writeIops: storageConfig.performanceConfig?.writeIops,
                writeBandwidth: storageConfig.performanceConfig?.writeBandwidth,
                latencyRead: storageConfig.performanceConfig?.latencyRead,
                latencyWrite: storageConfig.performanceConfig?.latencyWrite,
                localZoneRead: storageConfig.advancedConfig?.localZoneRead,
                capacityOptimization: storageConfig.capacityConfig?.optimization,
                capacityReservation: storageConfig.capacityConfig?.reservation,
                encryption: storageConfig.advancedConfig?.encryption,
                resiliencyMedia: storageConfig.resiliencyConfig?.mediaFailures || 0,
                resiliencyNode: storageConfig.resiliencyConfig?.nodeFailures || 0,
                resiliencyZone: storageConfig.resiliencyConfig?.zoneFailures || 0
            };
        } else {
            // For predefined policies, look up policy values from providerPolicies in Redux (fetched via /api/providers/:id/policies)
            const policiesForProvider = providerPolicies[storageConfig.providerId] || [];
            let predefinedPolicy = policiesForProvider.find(policy => policy.name === policyName);
            
            if (predefinedPolicy) {
                // Use values from the predefined policy
                policyValues = {
                    readIops: predefinedPolicy.iopsread,
                    readBandwidth: predefinedPolicy.bandwidthread,
                    writeIops: predefinedPolicy.iopswrite,
                    writeBandwidth: predefinedPolicy.bandwidthwrite,
                    latencyRead: predefinedPolicy.latencyread,
                    latencyWrite: predefinedPolicy.latencywrite,
                    localZoneRead: predefinedPolicy.localzoneread,
                    capacityOptimization: predefinedPolicy.capacityoptimization,
                    capacityReservation: predefinedPolicy.capacityreservation,
                    encryption: predefinedPolicy.encryption,
                    resiliencyMedia: predefinedPolicy.resiliencymedia,
                    resiliencyNode: predefinedPolicy.resiliencynode,
                    resiliencyZone: predefinedPolicy.resiliencyzone
                };
            } else {
                // Fallback to storageConfig values if policy not found
                console.warn(`Predefined policy "${policyName}" not found for provider ${storageConfig.providerId}, falling back to custom values`);
                policyValues = {
                    readIops: storageConfig.performanceConfig?.readIops,
                    readBandwidth: storageConfig.performanceConfig?.readBandwidth,
                    writeIops: storageConfig.performanceConfig?.writeIops,
                    writeBandwidth: storageConfig.performanceConfig?.writeBandwidth,
                    latencyRead: storageConfig.performanceConfig?.latencyRead,
                    latencyWrite: storageConfig.performanceConfig?.latencyWrite,
                    localZoneRead: storageConfig.advancedConfig?.localZoneRead,
                    capacityOptimization: storageConfig.capacityConfig?.optimization,
                    capacityReservation: storageConfig.capacityConfig?.reservation,
                    encryption: storageConfig.advancedConfig?.encryption,
                    resiliencyMedia: storageConfig.resiliencyConfig?.mediaFailures || 0,
                    resiliencyNode: storageConfig.resiliencyConfig?.nodeFailures || 0,
                    resiliencyZone: storageConfig.resiliencyConfig?.zoneFailures || 0
                };
            }
        }
        
        const volumeAttachment = {
            id: `volume-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            storageConfigId: storageConfigId,
            mountPath: dynamicMountPath,
            size: storageConfig.volumeConfig?.size || 500,
            performanceOverrides: {
                readIops: policyValues.readIops,
                readBandwidth: policyValues.readBandwidth,
                writeIops: policyValues.writeIops,
                writeBandwidth: policyValues.writeBandwidth,
                latencyRead: policyValues.latencyRead,
                latencyWrite: policyValues.latencyWrite
            },
            policyName: policyName,
            policyId: storageConfig.policyId, // Store policy ID for predefined policies
            resiliencyConfig: {
                mediaFailures: policyValues.resiliencyMedia,
                nodeFailures: policyValues.resiliencyNode,
                zoneFailures: policyValues.resiliencyZone
            },
            advancedConfig: {
                localZoneRead: policyValues.localZoneRead,
                encryption: policyValues.encryption
            },
            capacityConfig: {
                optimization: policyValues.capacityOptimization,
                reservation: policyValues.capacityReservation
            }
        };

        targetNodeGroup.attachedVolumes.push(volumeAttachment);
        setForm(updatedForm);
    };

    const handleVolumeUpdate = (updatedVolume, nodeGroupIndex) => {
        const updatedForm = { ...form };
        const targetNodeGroup = updatedForm.data.node.group[nodeGroupIndex];
        
        if (targetNodeGroup && targetNodeGroup.attachedVolumes) {
            const volumeIndex = targetNodeGroup.attachedVolumes.findIndex(vol => vol.id === updatedVolume.id);
            if (volumeIndex !== -1) {
                targetNodeGroup.attachedVolumes[volumeIndex] = updatedVolume;
                setForm(updatedForm);
            }
        }
    };

    const removeVolumeFromNode = (nodeIndex, volumeId) => {
        const updatedForm = { ...form };
        const targetNodeGroup = updatedForm.data.node.group[nodeIndex];
        
        if (targetNodeGroup && targetNodeGroup.attachedVolumes) {
            targetNodeGroup.attachedVolumes = targetNodeGroup.attachedVolumes.filter(vol => vol.id !== volumeId);
        }
        
        setForm(updatedForm);
    };

    // Head Node Volume Validation Helper (T016)
    const validateHeadNodeVolumeMountPath = (mountPath, existingVolumes = [], excludeVolumeId = null) => {
        const errors = [];
        
        // FR-007: Mount path must start with /
        if (!mountPath.startsWith('/')) {
            errors.push('Mount path must start with /');
        }
        
        // FR-005: Mount path must be unique across head node volumes
        const duplicates = existingVolumes.filter(v => 
            v.mountPath === mountPath && v.id !== excludeVolumeId
        );
        if (duplicates.length > 0) {
            errors.push('Mount path must be unique (already used by another head node volume)');
        }
        
        // Additional validation: no spaces or special characters except / and -
        if (!/^[a-zA-Z0-9\/_-]+$/.test(mountPath)) {
            errors.push('Mount path can only contain letters, numbers, /, _, and -');
        }
        
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    };

    // Head Node Volume Management Functions (T012-T014)
    const addVolumeToHeadNode = (storageConfigId) => {
        const storageConfig = availableStorageConfigs.find(config => config.id === storageConfigId);
        if (!storageConfig) return;

        const updatedForm = { ...form };
        
        // Initialize attachedVolumes array on server if not exists
        if (!updatedForm.data.server.attachedVolumes) {
            updatedForm.data.server.attachedVolumes = [];
        }

        // Create a new volume attachment using new schema
        const volumeIndex = updatedForm.data.server.attachedVolumes.length + 1;
        
        // Determine the volume prefix, with backward compatibility for old mountingPath
        let volumePrefix = storageConfig.volumeConfig?.volumePrefix;
        if (!volumePrefix && storageConfig.mountingPath) {
            const pathParts = storageConfig.mountingPath.split('/');
            const lastPart = pathParts[pathParts.length - 1];
            volumePrefix = lastPart.replace(/-\d+$/, '');
        }
        if (!volumePrefix) {
            volumePrefix = 'storage';
        }
        
        const basePath = storageConfig.volumeConfig?.basePath || '/mnt';
        const dynamicMountPath = `${basePath}/${volumePrefix}-${volumeIndex}`;
        
        // Determine policy name and get policy values
        const policyName = storageConfig.volumezSettings?.policyName || storageConfig.policyName || 'custom';
        let policyValues = {};
        
        if (policyName === 'custom') {
            // For custom policies, use values from storageConfig (current behavior)
            policyValues = {
                readIops: storageConfig.performanceConfig?.readIops,
                readBandwidth: storageConfig.performanceConfig?.readBandwidth,
                writeIops: storageConfig.performanceConfig?.writeIops,
                writeBandwidth: storageConfig.performanceConfig?.writeBandwidth,
                latencyRead: storageConfig.performanceConfig?.latencyRead,
                latencyWrite: storageConfig.performanceConfig?.latencyWrite,
                localZoneRead: storageConfig.advancedConfig?.localZoneRead,
                capacityOptimization: storageConfig.capacityConfig?.optimization,
                capacityReservation: storageConfig.capacityConfig?.reservation,
                encryption: storageConfig.advancedConfig?.encryption,
                resiliencyMedia: storageConfig.resiliencyConfig?.mediaFailures || 0,
                resiliencyNode: storageConfig.resiliencyConfig?.nodeFailures || 0,
                resiliencyZone: storageConfig.resiliencyConfig?.zoneFailures || 0
            };
        } else {
            // For predefined policies, look up policy values from providerPolicies in Redux (fetched via /api/providers/:id/policies)
            const policiesForProvider = providerPolicies[storageConfig.providerId] || [];
            let predefinedPolicy = policiesForProvider.find(policy => policy.name === policyName);
            
            if (predefinedPolicy) {
                // Use values from the predefined policy
                policyValues = {
                    readIops: predefinedPolicy.iopsread,
                    readBandwidth: predefinedPolicy.bandwidthread,
                    writeIops: predefinedPolicy.iopswrite,
                    writeBandwidth: predefinedPolicy.bandwidthwrite,
                    latencyRead: predefinedPolicy.latencyread,
                    latencyWrite: predefinedPolicy.latencywrite,
                    localZoneRead: predefinedPolicy.localzoneread,
                    capacityOptimization: predefinedPolicy.capacityoptimization,
                    capacityReservation: predefinedPolicy.capacityreservation,
                    encryption: predefinedPolicy.encryption,
                    resiliencyMedia: predefinedPolicy.resiliencymedia,
                    resiliencyNode: predefinedPolicy.resiliencynode,
                    resiliencyZone: predefinedPolicy.resiliencyzone
                };
            } else {
                // Fallback to storageConfig values if policy not found
                console.warn(`Predefined policy "${policyName}" not found for provider ${storageConfig.providerId}, falling back to custom values`);
                policyValues = {
                    readIops: storageConfig.performanceConfig?.readIops,
                    readBandwidth: storageConfig.performanceConfig?.readBandwidth,
                    writeIops: storageConfig.performanceConfig?.writeIops,
                    writeBandwidth: storageConfig.performanceConfig?.writeBandwidth,
                    latencyRead: storageConfig.performanceConfig?.latencyRead,
                    latencyWrite: storageConfig.performanceConfig?.latencyWrite,
                    localZoneRead: storageConfig.advancedConfig?.localZoneRead,
                    capacityOptimization: storageConfig.capacityConfig?.optimization,
                    capacityReservation: storageConfig.capacityConfig?.reservation,
                    encryption: storageConfig.advancedConfig?.encryption,
                    resiliencyMedia: storageConfig.resiliencyConfig?.mediaFailures || 0,
                    resiliencyNode: storageConfig.resiliencyConfig?.nodeFailures || 0,
                    resiliencyZone: storageConfig.resiliencyConfig?.zoneFailures || 0
                };
            }
        }
        
        const volumeAttachment = {
            id: `volume-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            storageConfigId: storageConfigId,
            mountPath: dynamicMountPath,
            size: storageConfig.volumeConfig?.size || 500,
            performanceOverrides: {
                readIops: policyValues.readIops,
                readBandwidth: policyValues.readBandwidth,
                writeIops: policyValues.writeIops,
                writeBandwidth: policyValues.writeBandwidth,
                latencyRead: policyValues.latencyRead,
                latencyWrite: policyValues.latencyWrite
            },
            policyName: policyName,
            policyId: storageConfig.policyId, // Store policy ID for predefined policies
            resiliencyConfig: {
                mediaFailures: policyValues.resiliencyMedia,
                nodeFailures: policyValues.resiliencyNode,
                zoneFailures: policyValues.resiliencyZone
            },
            advancedConfig: {
                localZoneRead: policyValues.localZoneRead,
                encryption: policyValues.encryption
            },
            capacityConfig: {
                optimization: policyValues.capacityOptimization,
                reservation: policyValues.capacityReservation
            },
            enablePerformanceDataSharing: false  // Initialize Performance Data Sharing flag
        };

        updatedForm.data.server.attachedVolumes.push(volumeAttachment);
        setForm(updatedForm);
    };

    const handleHeadNodeVolumeUpdate = (updatedVolume) => {
        const updatedForm = { ...form };
        
        if (updatedForm.data.server.attachedVolumes) {
            // Validate mount path before updating (T016)
            const validation = validateHeadNodeVolumeMountPath(
                updatedVolume.mountPath,
                updatedForm.data.server.attachedVolumes,
                updatedVolume.id
            );
            
            if (!validation.isValid) {
                // Show validation errors to user
                dispatch(ActionsDialog.openDialog({
                    children: (
                        <div>
                            <h3>Invalid Volume Configuration</h3>
                            <ul>
                                {validation.errors.map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    )
                }));
                return;
            }
            
            const volumeIndex = updatedForm.data.server.attachedVolumes.findIndex(vol => vol.id === updatedVolume.id);
            if (volumeIndex !== -1) {
                updatedForm.data.server.attachedVolumes[volumeIndex] = updatedVolume;
                setForm(updatedForm);
            }
        }
    };

    // Head node volume dialog handlers
    const openHeadVolumeEditDialog = (volume) => {
        const storageConfig = availableStorageConfigs.find(config => config.id === volume.storageConfigId);
        setHeadSelectedVolume(volume);
        setHeadSelectedStorageConfig(storageConfig || null);
        setHeadIsEditable(true);
        setHeadDialogOpen(true);
    };

    const closeHeadVolumeDialog = () => {
        setHeadDialogOpen(false);
        setHeadSelectedVolume(null);
        setHeadSelectedStorageConfig(null);
        setHeadIsEditable(false);
    };

    const saveHeadVolumeDialog = (updatedVolume) => {
        handleHeadNodeVolumeUpdate(updatedVolume);
        setHeadDialogOpen(false);
    };

    const removeVolumeFromHeadNode = (volumeId) => {
        const updatedForm = { ...form };
        
        if (updatedForm.data.server.attachedVolumes) {
            updatedForm.data.server.attachedVolumes = updatedForm.data.server.attachedVolumes.filter(vol => vol.id !== volumeId);
        }
        
        setForm(updatedForm);
    };

    // Volume dropdown helper functions
    const handleVolumeDropdownOpen = (event, nodeIndex) => {
        volumeDropdownAnchorEl.current[nodeIndex] = event.currentTarget;
        setVolumeDropdownOpen(prev => ({
            ...prev,
            [nodeIndex]: true
        }));
    };

    const handleVolumeDropdownClose = (nodeIndex) => {
        setVolumeDropdownOpen(prev => ({
            ...prev,
            [nodeIndex]: false
        }));
        volumeDropdownAnchorEl.current[nodeIndex] = null;
    };

    const handleVolumeConfigSelect = (nodeIndex, configId) => {
        addVolumeToNode(nodeIndex, configId);
        handleVolumeDropdownClose(nodeIndex);
    };

    // Head node volume dropdown helper functions
    const handleHeadNodeVolumeDropdownOpen = (event) => {
        headNodeVolumeDropdownAnchorEl.current = event.currentTarget;
        setHeadNodeVolumeDropdownOpen(true);
    };

    const handleHeadNodeVolumeDropdownClose = () => {
        setHeadNodeVolumeDropdownOpen(false);
        headNodeVolumeDropdownAnchorEl.current = null;
    };

    const handleHeadNodeVolumeConfigSelect = (configId) => {
        addVolumeToHeadNode(configId);
        handleHeadNodeVolumeDropdownClose();
    };

    const handleEdit = ({ confirmed }) => {
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }
        if (error) {
            dispatch(Actions.clearError());
        }
        if (form?.info?.lastDeployTime) form.info.lastDeployTime = 0;
        if (form?.info?.lastDestroyTime) form.info.lastDestroyTime = 0;

        // Create a copy of the form like handleSave does
        const updatedForm = {
            ...form,
            data: {
                ...form.data,
                network: {
                    ...form.data.network,
                    enable_node_internet_access: enableNodeInternetAccess,
                    enable_capacity_reservation: enableCapacityReservation,
                    capacity_reservation_auto_expire: capacityReservationAutoExpire,
                    capacity_reservation_expire_hours: capacityReservationExpireHours
                },
                server: {
                    ...form.data.server,
                    attachedVolumes: form.data.server.attachedVolumes || []  // Preserve head node volumes
                },
                // Preserve storageConfigurations from form data
                storageConfigurations: form.data.storageConfigurations || []
            }
        };

        updatedForm.data.node.group.forEach(node => {
            if (!isCompatibleForEFA(node.instance_id)) node.efa = false
        });
        if(currentMarketStack) {
            updatedForm.info.marketplace_head_image_id = currentMarketStack.config?.marketplace_images?.e4s?.[selectedRegionId]?.head_image_id || null;
            updatedForm.info.marketplace_compute_image_id = currentMarketStack.config?.marketplace_images?.e4s?.[selectedRegionId]?.compute_image_id || null;
        }
        const selectedZone = zones.find(zone => zone.zone_id === updatedForm.data.network.zone_id);
        if (selectedZone) {
            const formattedZoneName = formatZoneName(selectedZone.name);
            updatedForm.data.network.zone_name = formattedZoneName;
        } else {
            updatedForm.data.network.zone_name = '';
        }

        updatedForm.data.server.image_type = serverImageType;
        updatedForm.data.node.group.forEach((node, index) => {
            // In unified mode, all nodes use the same image type as the server
            node.image_type = imageMode === IMAGE_MODE.UNIFIED 
                ? serverImageType 
                : (nodeImageTypes[index] || IMAGE_TYPE.HEIDI_STACK);
        });

        // Add excluded global provision scripts (Feature 002 enhancement)
        if (excludedGlobalScripts && excludedGlobalScripts.length > 0) {
            updatedForm.excludedGlobalScripts = excludedGlobalScripts;
        } else {
            updatedForm.excludedGlobalScripts = [];
        }

        // Add cluster applications (Feature: cluster-apps)
        updatedForm.applications = clusterApplications || [];

        // Set imageMode in info object (matches schema)
        updatedForm.info.imageMode = imageMode;

        // Add owner selection if super-admin selected a different owner
        let ownerUsername;
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            ownerUsername = selectedOwner;
        }

        dispatch(Actions.editCluster(updatedForm, deletedPkgs, ownerUsername));
    };

    const handleSave = ({ confirmed }) => {
        if (props.setOldForm) {
            props.setOldForm(form);
        }
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }

        const selectedZone = zones.find(zone => zone.zone_id === form.data.network.zone_id);
        const formattedZoneName = selectedZone ? formatZoneName(selectedZone.name) : '';

        const updatedForm = {
            ...form,
            data: {
                ...form.data,
                network: {
                    ...form.data.network,
                    zone_name: formattedZoneName,
                    enable_node_internet_access: enableNodeInternetAccess,
                    enable_capacity_reservation: enableCapacityReservation,
                    capacity_reservation_auto_expire: capacityReservationAutoExpire,
                    capacity_reservation_expire_hours: capacityReservationExpireHours
                },
                server: {
                    ...form.data.server,
                    image_type: serverImageType,  // Apply server image type here
                    attachedVolumes: form.data.server.attachedVolumes || []  // Preserve head node volumes
                },
                // Preserve storageConfigurations from form data
                storageConfigurations: form.data.storageConfigurations || []
            },
            info: {
                ...form.info,
                prefix: inputValue,
                isMarketplace: isMarketStack,
                market_id: market_id_value,
                marketplace_head_image_id: marketplaceAMIIds?.head_image_id || null,
                marketplace_compute_image_id: marketplaceAMIIds?.compute_image_id || null,
                "os-type": form.info['os-type'],
				vncTokenAuthentication: isVncTokenAuthentication,
                vncRemoteClient: isVncRemoteClient,
                imageMode: imageMode
            },
            provider: 'aws'
        };

        // Apply node image types
        // In unified mode, all nodes use the same image type as the server
        updatedForm.data.node.group = updatedForm.data.node.group.map((node, index) => ({
            ...node,
            image_type: imageMode === IMAGE_MODE.UNIFIED 
                ? serverImageType 
                : (nodeImageTypes[index] || IMAGE_TYPE.HEIDI_STACK)
        }));

        // Add excluded global provision scripts (Feature 002 enhancement)
        // Always include this field (even if empty) to ensure consistent database state
        updatedForm.excludedGlobalScripts = excludedGlobalScripts || [];

        // Add cluster applications (Feature: cluster-apps)
        updatedForm.applications = clusterApplications || [];

        setForm(updatedForm);
        updatedForm.data.node.group.forEach(node => {
            if (!isCompatibleForEFA(node.instance_id)) node.efa = false;
        });

        // Add owner selection if super-admin selected a different owner
        const saveData = { ...updatedForm };
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            saveData.ownerUsername = selectedOwner;
        }

        dispatch(Actions.saveCluster(saveData));
    };


    const startSave = () => {
        setSaveAttempted(true);
        handleSave({ confirmed: false });
    }
    const startEdit = () => {
        setSaveAttempted(true);
        handleEdit({ confirmed: false });
    };

    // Popover delay and close handlers
    //const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    const handlePopoverOpen = (event, popoverId) => {
        setAnchorEl(event.currentTarget);
        setActivePopover(popoverId); // Set the active popover identifier
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setActivePopover(null); // Reset the active popover
    };
    const isODDCBurstingSelectionEnabled = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/moab/isIntegrated`)
            if (response.status !== 200) return false
            return response.data.isIntegrated
        } catch (error) {
            console.error('Error fetching from API:', error)
        }
    }

    const [moabIsIntegrated, setMoabIsIntegrated] = useState(null);

    useEffect(() => {
        const fetchDataAsync = async () => {
            const isIntegrated = await isODDCBurstingSelectionEnabled();
            setMoabIsIntegrated(isIntegrated);
        };

        fetchDataAsync();
    }, []);

    const [burstMode, setBurstMode] = useState(null)

    useEffect(() => {
        // Assuming `form.data.node.group` is an array of objects and each object has a `group_node_prefix`
        const initialValues = form?.data?.node?.group.map(group => group.group_node_prefix || '');
        setGroupNodeInputValues(initialValues);
    }, [form]);

    useEffect(() => {
        if (burstMode !== null) return
        if (props.type === 'new') {
            if (currentMarketStack ?
                setBurstMode('off') : setBurstMode('off'));
            return
        }
        if (form?.info?.bursting?.mode) setBurstMode(form.info.bursting.mode)
    }, [form, burstMode, currentMarketStack, props.type]);

    useEffect(() => {
        if (burstMode === null) return
        if (!form?.info) return
        if (!form.info.bursting) {
            form.info.bursting = {};
        }
        form.info.bursting.mode = burstMode
    }, [form, burstMode]);

    const validateServerPrefix = (prefix) => { // Since "Node Prefix" field is not a "Formsy" input. This is how we need to show validations.
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        if (/[^a-z0-9-]/g.test(prefix)) setPrefixError(invalidPrefixCharacter);
        else if (/^-|-$|--/g.test(prefix)) setPrefixError(invalidPrefixHyphenUsage);
        else setPrefixError('');
    }

    const validateNodePrefix = (prefix, index) => {
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        let error = '';
        if (/[^a-z0-9-]/g.test(prefix)) error = invalidPrefixCharacter;
        else if (/^-|-$|--/g.test(prefix)) error = invalidPrefixHyphenUsage;

        setNodePrefixErrors(prevErrors => {
            const newErrors = [...prevErrors];
            newErrors[index] = error;
            return newErrors;
        });
    };

    const areNonFormsyRequiredFieldsValid = () => {
        // check that the server prefix and all of the prefixes of compute nodes are in a non-error state and have content
        const serverPrefixisValid = !prefixError && form.data.server.image_name
        // In unified mode, node prefixes are not required since compute nodes use the same image as head node
        const nodePrefixesAreValid = imageMode === IMAGE_MODE.UNIFIED 
            ? true 
            : (nodePrefixErrors.every(error => error === '') && form.data.node.group.every(node => node.group_node_prefix))
        
        // Check Torque configuration validation
        let torqueConfigValid = true;
        if (form.data.manager === RESOURCE_MANAGER.TORQUE) {
            const hasValidHostname = form.data.moab?.hostname && form.data.moab.hostname.trim() !== '';
            const hasValidIP = form.data.moab?.ip && form.data.moab.ip.trim() !== '';
            torqueConfigValid = hasValidHostname && hasValidIP;
        }
        
        // Check storage configuration validation - all fields must be filled
        let storageConfigsValid = true;
        
        // First check the validation status from StorageConfigurationSection
        if (!storageConfigValidation.isValid) {
            storageConfigsValid = false;
        } else if (form.data.storageConfigurations && form.data.storageConfigurations.length > 0) {
            storageConfigsValid = form.data.storageConfigurations.every(config => {
                // Configuration name is required
                const hasValidName = config.name && config.name.trim() !== '';
                // Basic required fields - volume name is no longer required as it's generated server-side
                const hasValidSize = config.volumeConfig?.size !== undefined && config.volumeConfig.size !== '' && config.volumeConfig.size > 0;
                // For backward compatibility, use defaults if fields are missing
                const basePath = config.volumeConfig?.basePath || '/mnt';
                const volumePrefix = config.volumeConfig?.volumePrefix || config.providerName?.toLowerCase().replace(/\s+/g, '-') || 'storage';
                const hasValidBasePath = basePath && basePath.trim() !== '';
                const hasValidVolumePrefix = volumePrefix && volumePrefix.trim() !== '';
                
                // Media configuration validation (if media fields are present, both must be filled)
                let mediaConfigValid = true;
                if (config.mediaType || config.stackName) {
                    mediaConfigValid = config.mediaType && config.mediaType.trim() !== '' && 
                                     config.stackName && config.stackName.trim() !== '';
                }
                
                // Volume configuration validation (if volume fields are present, both must be filled)
                // Exception: if attaching to head node, app instance type is not required
                let appConfigValid = true;
                if (config.appInstanceType || config.appStackName) {
                    if (config.volumezSettings?.attachToHeadNode) {
                        // When attaching to head node, only stack name is required if specified
                        appConfigValid = !config.appStackName || (config.appStackName && config.appStackName.trim() !== '');
                    } else {
                        // Normal case: both must be filled if either is present
                        // Handle both old (string) and new (array) appInstanceType formats
                        let appInstanceTypeValid = false;
                        if (Array.isArray(config.appInstanceType)) {
                            // New format: array of node group configurations
                            appInstanceTypeValid = config.appInstanceType.length > 0;
                        } else if (typeof config.appInstanceType === 'string') {
                            // Old format: string instance type
                            appInstanceTypeValid = config.appInstanceType.trim() !== '';
                        }
                        
                        appConfigValid = appInstanceTypeValid && 
                                       config.appStackName && config.appStackName.trim() !== '';
                    }
                }
                
                // Performance configuration validation for volumez provider
                let performanceConfigValid = true;
                if (config.providerType === 'volumez') {
                    // Check if performance config fields are present and valid
                    if (config.performanceConfig) {
                        const hasValidIOPS = config.performanceConfig.iops !== undefined && 
                                           config.performanceConfig.iops !== '' && 
                                           config.performanceConfig.iops >= 100;
                        const hasValidBandwidth = config.performanceConfig.bandwidth !== undefined && 
                                                config.performanceConfig.bandwidth !== '' && 
                                                config.performanceConfig.bandwidth >= 50;
                        performanceConfigValid = hasValidIOPS && hasValidBandwidth;
                    }
                }
                
                return hasValidName && hasValidSize && hasValidBasePath && hasValidVolumePrefix && mediaConfigValid && appConfigValid && performanceConfigValid;
            });
        }
        
        return serverPrefixisValid && nodePrefixesAreValid && torqueConfigValid && storageConfigsValid;
    }

    // Add this function to sort instance sizes
    const sortInstanceSizes = (instances) => {
        return [...instances].sort((a, b) => {
            // Extract size information - looking for pattern like "t2.micro", "m5.large", etc.
            const extractSize = (instance) => {
                const parts = instance.instance_id.split('.');
                if (parts.length < 2) return 0;
                
                // Size hierarchy: nano < micro < small < medium < large < xlarge < 2xlarge, etc.
                const sizeMap = {
                    'nano': 1,
                    'micro': 2,
                    'small': 3,
                    'medium': 4,
                    'large': 5,
                    'xlarge': 6
                };
                
                const size = parts[1];
                if (size in sizeMap) return sizeMap[size];
                
                // Handle cases like "2xlarge", "4xlarge", etc.
                const match = size.match(/(\d+)xlarge/);
                if (match) return 6 + parseInt(match[1]);
                
                return 100; // Default value for unknown sizes
            };
            
            const sizeA = extractSize(a);
            const sizeB = extractSize(b);
            
            return sizeA - sizeB;
        });
    };

    // Update the filtered server instances when serverInstanceSizes or search changes
    useEffect(() => {
        if (serverInstanceSizes) {
            const sortedInstances = sortInstanceSizes(serverInstanceSizes);
            
            if (!headNodeSearch) {
                setFilteredServerInstances(sortedInstances);
            } else {
                const filtered = sortedInstances.filter(instance => 
                    instance.instance_id.toLowerCase().includes(headNodeSearch.toLowerCase()) ||
                    instance.name.toLowerCase().includes(headNodeSearch.toLowerCase())
                );
                setFilteredServerInstances(filtered);
            }
        }
    }, [serverInstanceSizes, headNodeSearch]);

    // Handle head node search input change
    const handleHeadNodeSearchChange = (event) => {
        setHeadNodeSearch(event.target.value);
        // Always keep dropdown open when typing
        setHeadNodeDropdownOpen(true);
    };

    // Toggle head node dropdown
    const toggleHeadNodeDropdown = () => {
        const newOpenState = !headNodeDropdownOpen;
        setHeadNodeDropdownOpen(newOpenState);
        
        // When opening the dropdown, reset the filter to show all instances
        if (newOpenState && serverInstanceSizes) {
            setFilteredServerInstances(sortInstanceSizes(serverInstanceSizes));
        }
    };

    // Select head node instance
    const selectHeadNodeInstance = (instanceId) => {
        // Find the selected instance to get its name
        const selectedInstance = serverInstanceSizes.find(instance => instance.instance_id === instanceId);
        if (selectedInstance) {
            setHeadNodeSearch(selectedInstance.name);
        }
        setServerObj({ name: 'instance_id', value: instanceId });
        setHeadNodeDropdownOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (headNodeInputRef.current && !headNodeInputRef.current.contains(event.target)) {
                setHeadNodeDropdownOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Update the filtered node instances when nodeInstanceSizes changes
    useEffect(() => {
        if (nodeInstanceSizes) {
            setFilteredNodeInstances(sortInstanceSizes(nodeInstanceSizes));
        }
    }, [nodeInstanceSizes]);
    
    // Handle node search input change
    const handleNodeSearchChange = (i, event) => {
        const searchValue = event.target.value;
        setNodeSearchValues(prev => ({...prev, [i]: searchValue}));
        
        // Always keep dropdown open when typing
        setNodeDropdownOpen(prev => ({...prev, [i]: true}));
        
        // Filter the instances based on search
        if (!searchValue) {
            setFilteredNodeInstances(sortInstanceSizes(nodeInstanceSizes));
        } else {
            const filtered = nodeInstanceSizes.filter(instance => 
                instance.instance_id.toLowerCase().includes(searchValue.toLowerCase()) ||
                instance.name.toLowerCase().includes(searchValue.toLowerCase())
            );
            setFilteredNodeInstances(sortInstanceSizes(filtered));
        }
    };
    
    // Toggle node dropdown
    const toggleNodeDropdown = (i) => {
        setNodeDropdownOpen(prev => {
            const newState = {...prev};
            // Close all other dropdowns
            Object.keys(newState).forEach(key => {
                newState[key] = false;
            });
            // Toggle the current dropdown
            const newOpenState = !prev[i];
            newState[i] = newOpenState;
            
            // When opening the dropdown, reset the filter to show all instances
            if (newOpenState && nodeInstanceSizes) {
                setFilteredNodeInstances(sortInstanceSizes(nodeInstanceSizes));
            }
            
            return newState;
        });
    };
    
    // Select node instance
    const selectNodeInstance = (i, instanceId) => {
        // Find the selected instance to get its name
        const selectedInstance = nodeInstanceSizes.find(instance => instance.instance_id === instanceId);
        if (selectedInstance) {
            setNodeSearchValues(prev => ({...prev, [i]: selectedInstance.name}));
        }
        setInstanceId(i, instanceId);
        setNodeDropdownOpen(prev => ({...prev, [i]: false}));
    };
    
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            
            Object.keys(nodeInputRefs.current).forEach(key => {
                if (nodeInputRefs.current[key] && nodeInputRefs.current[key].contains(event.target)) {
                    clickedInside = true;
                }
            });
            
            if (!clickedInside) {
                setNodeDropdownOpen({});
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (form?.data?.server?.instance_id && serverInstanceSizes?.length) {
            const headInstance = serverInstanceSizes.find(s => s.instance_id === form.data.server.instance_id);
            if (headInstance) {
                setHeadNodeSearch(headInstance.name);
            }
        }
        
        if (form?.data?.node?.group?.length && nodeInstanceSizes?.length) {
            const nodeValues = {};
            form.data.node.group.forEach((node, index) => {
                if (node.instance_id) {
                    const nodeInstance = nodeInstanceSizes.find(s => s.instance_id === node.instance_id);
                    if (nodeInstance) {
                        nodeValues[index] = nodeInstance.name;
                    }
                }
            });
            setNodeSearchValues(prev => ({...prev, ...nodeValues}));
        }
    }, [form, serverInstanceSizes, nodeInstanceSizes]);

    
    // Function to clear the head node search input and keep dropdown open
    const clearHeadNodeSearch = () => {
        setHeadNodeSearch('');
        setFilteredServerInstances(sortInstanceSizes(serverInstanceSizes));
        // Keep dropdown open after clearing
        setHeadNodeDropdownOpen(true);
    };

    // Function to clear a node search input and keep dropdown open
    const clearNodeSearch = (i) => {
        setNodeSearchValues(prev => ({...prev, [i]: ''}));
        setFilteredNodeInstances(sortInstanceSizes(nodeInstanceSizes));
        // Keep dropdown open after clearing
        setNodeDropdownOpen(prev => ({...prev, [i]: true}));
    };

    // Add this useEffect after the other useEffect blocks
    useEffect(() => {
        const downloadProvisionScript = async () => {
            if (
                currentMarketStack?.config?.provision_script && 
                form?.data?.provision &&
                !form.data.provision.script // Only download if no script already exists
            ) {
                dispatch(ActionsDialog.toggleLoading());
                try {
                    const scriptContent = await dispatch(MarketActions.getProvisionScript(currentMarketStack.config.provision_script));
                    setForm(_.set({ ...form }, 'data', { 
                        ...form.data, 
                        provision: { 
                            ...form.data.provision, 
                            script: scriptContent 
                        } 
                    }));
                } catch (error) {
                    console.error("Error downloading provision script:", error);
                } finally {
                    dispatch(ActionsDialog.toggleLoading());
                }
            }
        };
        
        downloadProvisionScript();
    }, [currentMarketStack, form, dispatch, setForm]);

    // Handle storage configuration changes - sync with node groups
    const handleStorageConfigurationChange = (storageConfigurations, metadata = {}) => {
        if (!form || !form.data || !form.data.node) return;
        
        // storageConfigurations now contains only complete media configurations
        // metadata contains additional info like allConfigs, totalConfigs, validation status, etc.
        const { allConfigs = [], completedMediaConfigs = 0, totalConfigs = 0, validation = { isValid: true, errors: [] } } = metadata;
        
        // Update storage configuration validation status
        setStorageConfigValidation(validation);
        
        // Update available storage configurations for volume management
        setAvailableStorageConfigs(storageConfigurations || []);
        
        const currentGroups = [...form.data.node.group];
        
        // Keep regular groups (not storage-managed groups)
        const regularGroups = currentGroups.filter(group => 
            !group.storageReference && group.nodeType !== 'media'
        );
        
        // Process storage configurations to update or create storage-managed groups
        const managedGroups = [];
        const processedStorageIds = new Set();
        
        // Generate a consistent storage reference ID for storage configs
        const generateStorageReference = (config, nodeType) => {
            // Use config ID if available
            if (config.id) {
                // Match the existing database pattern for consistency
                return `${nodeType}-${config.id}`;
            }
            
            // Generate deterministic ID based on config properties (fallback)
            const configHash = JSON.stringify({
                name: config.name,
                nodeType: config.nodeType,
                instanceType: config.instanceType,
                mediaType: config.mediaType,
                stackName: config.stackName
            }).split('').reduce((a, b) => {
                a = ((a << 5) - a) + b.charCodeAt(0);
                return a & a;
            }, 0);
            
            const baseName = config.name || 'unnamed';
            return `${nodeType}-${baseName}-${Math.abs(configHash)}`;
        };

        // Process all storage configurations (media only)
        storageConfigurations.forEach((config, index) => {
            
            // Determine node types and instance types from storage configuration
            const nodeTypes = [];
            
            // Check for media configuration - ONLY create if both fields are present
            if (config.mediaType && 
                config.stackName && 
                config.stackName.trim() !== '' &&
                (config.provider === 'volumez' || config.providerType === 'volumez')) {
                nodeTypes.push({
                    nodeType: 'media',
                    instanceType: config.mediaType
                });
            }
            
            // Process each node type for this storage configuration
            nodeTypes.forEach(({ nodeType, instanceType }) => {
                const storageReference = generateStorageReference(config, nodeType);
                processedStorageIds.add(storageReference);
                
                // Try to find existing group by storage reference (most reliable)
                let existingGroup = currentGroups.find(group => 
                    group.storageReference === storageReference
                );
                
                // Fallback: Find by node type and matching properties (for legacy support)
                if (!existingGroup) {
                    existingGroup = currentGroups.find(group => 
                        group.nodeType === nodeType &&
                        group.instance_id === instanceType &&
                        (group.group_node_prefix === config.stackName || 
                         (!group.group_node_prefix && !config.stackName)) &&
                        (group.group_node_prefix_label === config.name || 
                         (nodeType === 'media' && group.group_node_prefix_label?.includes('Media Storage')))
                    );
                }
                
                const stackName = config.stackName;
                
                // Calculate the required node count based on node type and configuration
                let nodeCount = 1; // Default
                if (nodeType === 'media' && config.requiredNodes && config.requiredNodes > 0) {
                    // For media nodes, always use the calculated required nodes from resiliency config
                    // This ensures automatic updates when resiliency values change
                    nodeCount = config.requiredNodes;
                } else {
                    // Fallback: preserve existing count or use default
                    nodeCount = existingGroup?.count || 1;
                }
                
                const nodeGroup = {
                    ...(existingGroup || {}),
                    _id: existingGroup?._id || false,
                    id: existingGroup?.id || storageReference,
                    instance_id: instanceType,
                    group_node_prefix: stackName || existingGroup?.group_node_prefix || '',
                    group_node_prefix_label: config.name || existingGroup?.group_node_prefix_label || 
                        `Media Storage ${config.id}`,
                    count: nodeCount,
                    image_type: existingGroup?.image_type || null,
                    efa: existingGroup?.efa || false,
                    zone_id: config.mediaZoneId || existingGroup?.zone_id || null, // Zone selection from storage config
                    storageReference: storageReference, // Database field
                    nodeType: nodeType, // Database field ('media')
                    // Frontend-only flags for UI rendering (deprecated but kept for compatibility)
                    isMediaGroup: nodeType === 'media'
                };
                
                managedGroups.push(nodeGroup);
            });
        });
        
        // Clean up orphaned storage-managed groups and incomplete configurations
        // Groups are considered orphaned if:
        // 1. Their storage reference is no longer in the processed list (config deleted)
        // 2. Their associated storage configuration has incomplete information
        const orphanedGroups = currentGroups.filter(group => {
            if (!group.storageReference) return false; // Not a storage-managed group
            
            // If the group's reference wasn't processed, it's orphaned
            if (!processedStorageIds.has(group.storageReference)) {
                return true;
            }
            
            // Additional check: Find the associated storage config and verify completeness
            const associatedConfig = storageConfigurations.find(config => {
                const mediaRef = generateStorageReference(config, 'media');
                return group.storageReference === mediaRef;
            });
            
            if (associatedConfig) {
                // Check if the configuration is complete for this node type
                if (group.nodeType === 'media') {
                    return !associatedConfig.mediaType || 
                           !associatedConfig.stackName || 
                           associatedConfig.stackName.trim() === '';
                }
            }
            
            return false; // Keep the group
        });
        
        // Clean up attached volumes in all node groups that reference deleted storage configurations
        const validStorageConfigIds = new Set(storageConfigurations.map(config => config.id));
        const allGroupsWithCleanedVolumes = [...regularGroups, ...managedGroups].map(group => {
            if (group.attachedVolumes && group.attachedVolumes.length > 0) {
                // Filter out volumes that reference deleted storage configurations
                const validVolumes = group.attachedVolumes.filter(volume => 
                    validStorageConfigIds.has(volume.storageConfigId)
                );
                
                // Only update the group if volumes were actually removed
                if (validVolumes.length !== group.attachedVolumes.length) {
                    return {
                        ...group,
                        attachedVolumes: validVolumes
                    };
                }
            }
            return group;
        });
        
        // Clean up attached volumes in head node that reference deleted storage configurations
        let cleanedHeadNodeVolumes = form.data.server.attachedVolumes || [];
        if (cleanedHeadNodeVolumes.length > 0) {
            cleanedHeadNodeVolumes = cleanedHeadNodeVolumes.filter(volume => 
                validStorageConfigIds.has(volume.storageConfigId)
            );
        }
        
        // Combine regular groups with updated storage-managed groups
        const allGroups = allGroupsWithCleanedVolumes;
        
        // Update the form with the new groups and cleaned head node volumes
        setForm(prevForm => ({
            ...prevForm,
            data: {
                ...prevForm.data,
                server: {
                    ...prevForm.data.server,
                    attachedVolumes: cleanedHeadNodeVolumes
                },
                node: {
                    ...prevForm.data.node,
                    group: allGroups
                }
            }
        }));
    };

    // Initialize storage configurations when form loads - restore storage-managed nodes
    // Note: Only run on initial form load (form.id change), not on every storage config change
    // The onStorageConfigurationChange callback handles updates from StorageConfigurationSection
    useEffect(() => {
        if (form && form.data && form.data.storageConfigurations && form.data.storageConfigurations.length > 0) {
            handleStorageConfigurationChange(form.data.storageConfigurations);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form?.id]); // Only trigger on form load, not on storage config changes

    // Initialize attachedVolumes for node groups from form data
    useEffect(() => {
        if (form?.data?.node?.group) {
            // Ensure each node group has an attachedVolumes array if it doesn't exist
            const updatedForm = { ...form };
            let hasChanges = false;
            
            updatedForm.data.node.group.forEach((group, index) => {
                if (!group.attachedVolumes) {
                    group.attachedVolumes = [];
                    hasChanges = true;
                }
            });
            
            if (hasChanges) {
                setForm(updatedForm);
            }
        }
    }, [form?.data?.node?.group?.length]); // Only run when node groups change

    // Initialize attachedVolumes for head node from form data
    useEffect(() => {
        if (form?.data?.server && !form.data.server.attachedVolumes) {
            const updatedForm = { ...form };
            updatedForm.data.server.attachedVolumes = [];
            setForm(updatedForm);
        }
    }, [form?.id]); // Only run when form loads or changes

    // Define updated styles for the form sections
    const cardStyle = {
        marginBottom: '24px',
        boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
        borderRadius: '8px',
        overflow: 'visible'
    };

    const cardHeaderStyle = {
        paddingBottom: '8px',
        backgroundColor: '#f7f9fc'
    };

    const sectionTitleStyle = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#0f2147'
    };

    const inputGroupStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: '16px',
        alignItems: 'flex-start'
    };

    const tooltipIconStyle = {
        fontSize: '16px',
        marginLeft: '4px',
        color: '#6b778c',
        verticalAlign: 'middle',
        cursor: 'help'
    };

    const infoChipStyle = {
        backgroundColor: '#E3F2FD',
        height: '24px',
        fontSize: '12px',
        marginLeft: '8px'
    };

    const addButtonStyle = {
        marginLeft: '8px',
        backgroundColor: '#2196F3',
        '&:hover': {
            backgroundColor: '#1976D2',
        }
    };
    
    const removeButtonStyle = {
        backgroundColor: '#f44336',
        '&:hover': {
            backgroundColor: '#d32f2f',
        },
        marginLeft: '8px'
    };

    const formFieldStyle = { 
        flex: 1 
    };

    const formFieldFlex2Style = {
        flex: 2 
    };

    const columnContainerStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '24px',
        width: '100%'
    };

    const columnStyle = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0, // This prevents flex items from overflowing
    };

    useEffect(() => {
        // Initialize node image types from form data when available
        if (form?.data?.node?.group) {
            const initialTypes = {};
            form.data.node.group.forEach((node, index) => {
                initialTypes[index] = node.image_type || IMAGE_TYPE.HEIDI_STACK;
            });
            setNodeImageTypes(initialTypes);
        }
    }, [form?.data?.node?.group]);
    
    useEffect(() => {
        // Only run this once when the form initially loads or when editing
        if (form?.data?.server?.image_type &&
            (!serverImageType || serverImageType === IMAGE_TYPE.HEIDI_STACK)) {
            setServerImageType(form.data.server.image_type);
        }
    }, [form?.data?.server?.image_type, serverImageType]);

    useEffect(() => {
        // Initialize imageMode from form data when editing
        if (form?.info?.imageMode) {
            setImageMode(form.info.imageMode);
        }
    }, [form?.info?.imageMode]);

    // Sync node groups with head node settings when in UNIFIED mode
    useEffect(() => {
        if (imageMode === IMAGE_MODE.UNIFIED && form?.data?.node?.group && form?.data?.server?.image_name) {
            // Update all node groups to use server's image_name as their prefix
            const updatedGroups = form.data.node.group.map(node => ({
                ...node,
                group_node_prefix: form.data.server.image_name,
                image_type: serverImageType
            }));
            
            // Only update if there are actual changes to avoid infinite loops
            const needsUpdate = form.data.node.group.some((node, index) => 
                node.group_node_prefix !== updatedGroups[index].group_node_prefix ||
                node.image_type !== updatedGroups[index].image_type
            );
            
            if (needsUpdate) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        node: {
                            ...prevForm.data.node,
                            group: updatedGroups
                        }
                    }
                }));
                
                // Also update nodeImageTypes state
                const newTypes = {};
                updatedGroups.forEach((_, index) => {
                    newTypes[index] = serverImageType;
                });
                setNodeImageTypes(newTypes);
            }
        }
    }, [imageMode, serverImageType, form?.data?.server?.image_name]);

    // Add this dedicated handler function for server image type changes
    const handleServerImageTypeChange = (e) => {
        const newValue = e.target.value;
        
        // Update local state
        setServerImageType(newValue);
        
        // Directly update form data
        setForm(prevForm => ({
            ...prevForm,
            data: {
                ...prevForm.data,
                server: {
                    ...prevForm.data.server,
                    image_type: newValue
                }
            }
        }));
    };


    const setNodeImageType = (index, type) => {
        setNodeImageTypes(prev => ({
            ...prev,
            [index]: type
        }));
        
        setForm(prevForm => {
            const updatedGroups = [...prevForm.data.node.group];
            updatedGroups[index] = {
                ...updatedGroups[index],
                image_type: type
            };
            return {
                ...prevForm,
                data: {
                    ...prevForm.data,
                    node: {
                        ...prevForm.data.node,
                        group: updatedGroups
                    }
                }
            };
        });
    };

    // Add this useEffect to reset burst mode when manager changes from Torque to something else
    useEffect(() => {
        if (form?.data?.manager && form.data.manager !== RESOURCE_MANAGER.TORQUE && burstMode !== 'off') {
            setBurstMode('off');
            if (form?.info?.bursting) {
                form.info.bursting.mode = 'off';
            }
        }
    }, [form?.data?.manager, burstMode]);

    // Clear Moab data when manager changes away from Torque
    useEffect(() => {
        if (form?.data?.manager && form.data.manager !== RESOURCE_MANAGER.TORQUE) {
            if (form.data.moab && (form.data.moab.hostname || form.data.moab.ip)) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        moab: {
                            ...prevForm.data.moab,
                            hostname: '',
                            ip: ''
                        }
                    }
                }));
            }
        }
    }, [form?.data?.manager, setForm]);

    return (
        <React.Fragment>
            {form && (
                <React.Fragment>
                    <DialogTitle className={clsx(classes.modalHeader, 'h-54 min-h-54 p-20')}>
                        <div className="flex flex-1 w-full items-center justify-between">
                            <div className="flex flex-col max-w-full">
                                <div className="flex items-center max-w-full">
                                    <FuseAnimate animation="transition.expandIn" delay={300}>
                                        <img
                                            id="aws_provider-logo"
                                            className="w-32 sm:w-48 mr-8 sm:mr-16 rounded"
                                            src={imageSrc} alt="Provider Logo"
                                        />
                                    </FuseAnimate>
                                    <div className="flex flex-col min-w-0">
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <Typography id="aws_cluster-name-header" className="text-16 text-white sm:text-20 truncate">
                                                {title}
                                            </Typography>
                                        </FuseAnimate>
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <Typography id="aws_provider-name-header" className="text-white" variant="caption">
                                                {`Amazon Web Services`}
                                            </Typography>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Button
                                    className="whitespace-no-wrap mr-2"
                                    id="aws_advanced-btn"
                                    variant="contained"
                                    disabled={loading}
                                    onClick={() => setAdvanced(!advanced)}
                                >
                                    {advanced ? "Basic" : "Advanced"}
                                </Button>
                                {props.type === 'new' && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="aws_save-btn"
                                        disabled={
                                            !isFormValid || 
                                            !areNonFormsyRequiredFieldsValid()
                                        }
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            startSave();
                                            dispatch(MarketActions.clearStack());
                                        }}
                                    >
                                        {'Save'}
                                    </Button>
                                )}
                                {props.type === 'edit' && form.info.state === CLUSTER_STATES.DESTROYED && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="aws_save-btn"
                                        disabled={
                                            !isFormValid || 
                                            loading || 
                                            !form.data.server.image_name ||
                                            !areNonFormsyRequiredFieldsValid()
                                        }
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            startEdit()
                                            dispatch(MarketActions.clearStack())
                                        }}
                                    >
                                        Update
                                    </Button>
                                )}
                                <Button
                                    className="whitespace-no-wrap ml-2"
                                    id="aws_close-btn"
                                    variant="contained"
                                    onClick={handleClose}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>

                    {/* Quota Warnings */}
                    {(usedCpus > limitCpus || usedNetwork > limitNetwork || usedIntances > limitIntances) && (
                        <Box p={2} my={2} bgcolor="#FFF3E0" borderRadius={1}>
                            <Typography variant="subtitle2" style={{display: 'flex', alignItems: 'center', color: '#E65100'}}>
                                <Icon style={{marginRight: '8px'}}>warning</Icon> 
                                Quota Warning
                            </Typography>
                            <Box mt={1}>
                                {usedCpus > limitCpus && (
                                    <Typography variant="body2" color="textSecondary">
                                        The quota of CPUs established by the provider is exceeded.
                                    </Typography>
                                )}
                                {usedNetwork > limitNetwork && (
                                    <Typography variant="body2" color="textSecondary">
                                        The quota of network established by the provider is exceeded.
                                    </Typography>
                                )}
                                {usedIntances > limitIntances && (
                                    <Typography variant="body2" color="textSecondary">
                                        The quota of instances established by the provider is exceeded.
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    )}
            
                    <DialogContent className={clsx(classes.content, 'p-16 -mr-200 ml-20')}>
                        <DisabledFormWrapper isDisabled={disableInputs}>
                            <Formsy ref={formRef} onValid={enableButton} onInvalid={disableButton} className="!w-full">
                                {/* Owner Selection Card - Only for Super Admin in Advanced Mode */}
                                <OwnerSelectionCard
                                    value={selectedOwner}
                                    onChange={setSelectedOwner}
                                    label="Cluster Owner"
                                    title="Cluster Owner"
                                    showInAdvancedMode={true}
                                    advanced={advanced}
                                    disabled={props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED}
                                />

                                {/* Two-column layout container */}
                                <div style={columnContainerStyle}>
                                    {/* Left Column */}
                                    <div style={columnStyle}>
                                        {/* Basic Information Section */}
                                        <Card style={cardStyle}>
                                            <CardHeader         
                                                title={
                                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>info</Icon>
                                                            <Typography style={sectionTitleStyle}>Basic Information</Typography>
                                                        </Box>
                                                        {props.type === 'edit' && form?.id && (
                                                            <Typography style={{color: '#666', fontSize: '14px', fontWeight: 'normal'}}>
                                                                ID: {form.id}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                    {/* Left Column - fixed width */}
                                                    <div style={{ width: '48%' }}>
                                                        <TextFieldFormsy
                                                            className={clsx(classes.input, 'mr-16')}
                                                            style={{ marginBottom: '16px', width: '150%' }}
                                                            id="aws_name"
                                                            name="name"
                                                            label="Cluster Name"
                                                            type="text"
                                                            variant="outlined"
                                                            value={form?.name}
                                                            onChange={handleChange}
                                                            required
                                                            placeholder="Your Cluster Name (No Spaces or Capitals)"
                                                            validations={{
                                                                isNameUnique: (formValues, fieldValue) => {
                                                                    if (clusterNames.includes(fieldValue) && !(props.type === 'edit')) {
                                                                        return 'This name is already in use. Please choose a different one.';
                                                                    }
                                                                    return true;
                                                                },
                                                                isString: (formValues, fieldValue) => typeof fieldValue === 'string' || 'Name must be a string.',
                                                                doesNotExceedMaxLength: (formValues, fieldValue) =>
                                                                    !fieldValue || fieldValue.length <= 40 || 'Name cannot exceed 40 characters.',
                                                                hasValidCharacters: (formValues, fieldValue) =>
                                                                    !fieldValue || !/[^a-z0-9-]/g.test(fieldValue) || 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                                                doesNotStartOrEndWithHyphen: (formValues, fieldValue) =>
                                                                    !fieldValue || !/^-|-$|--/g.test(fieldValue) || 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                                                doesNotStartWithInteger: (formValues, fieldValue) =>
                                                                    !fieldValue || !/^\d/.test(fieldValue) || 'Name cannot start with a number.',
                                                            }}
                                                            validationErrors={{
                                                                isNameUnique: 'This name is already in use. Please choose a different one.',
                                                                isString: 'Name must be a string.',
                                                                doesNotExceedMaxLength: 'Name cannot exceed 40 characters.',
                                                                hasValidCharacters: 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                                                doesNotStartOrEndWithHyphen: 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                                                doesNotStartWithInteger: 'Name cannot start with a number.'
                                                            }}
                                                        />
                                                        <SelectFormsy
                                                            className={clsx(classes.input)}
                                                            id="aws_os-type"
                                                            name="os-type"
                                                            label="Operating System"
                                                            type="select"
                                                            variant="outlined"
                                                            value={getDefaultOsType()}
                                                            onChange={e => setInfoObj(e.target)}
                                                            required
                                                            disabled={marketplaceOSTypes && supportedOSs.filter(os => marketplaceOSTypes.includes(os)).length === 1}
                                                            style={{  width: '400px' }}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    style: { maxHeight: 300}
                                                                }
                                                            }}
                                                        >
                                                            {supportedOSs
                                                                .filter(os => !marketplaceOSTypes || marketplaceOSTypes.includes(os))
                                                                .map((os, index) => (
                                                                    <MenuItem
                                                                        id={`os-${os}`}
                                                                        key={index}
                                                                        value={os}
                                                                    >
                                                                        {os}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </SelectFormsy>
                                                    </div>

                                                    {/* Divider - centered */}
                                                    <div style={{ 
                                                        width: '2px', 
                                                        backgroundColor: '#e0e0e0', 
                                                        margin: '10px 0',
                                                        alignSelf: 'stretch'
                                                    }} />

                                                    {/* Right Column - fixed width */}
                                                    <div style={{ width: '48%' }}>
                                                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                                            <TextField
                                                                ref={textFieldRef}
                                                                label="Stack"
                                                                className={clsx(classes.input)}
                                                                style={{ flex: 1 }}
                                                                placeholder="Your Image Name or Select Stack"
                                                                required
                                                                disabled={Boolean(currentMarketStack) && !marketplaceAllowImageSelection}
                                                                value={form.data.server.image_name || ''}
                                                                onChange={e => {
                                                                    form.data.server.image_name = e.target.value
                                                                    setForm({ ...form })
                                                                    validateServerPrefix(e.target.value)
                                                                }}
                                                                variant="outlined"
                                                                error={prefixError ? true : false}
                                                                helperText={prefixError}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <IconButton
                                                                                disabled={Boolean(currentMarketStack) && !marketplaceAllowImageSelection}
                                                                                onClick={handleMenuOpen}>
                                                                                <ArrowDropDownIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                            
                                                            <SelectFormsy
                                                                className={clsx(classes.input)}
                                                                id="aws_server_image_type"
                                                                name="server_image_type"
                                                                label="Image Type"
                                                                type="select"
                                                                variant="outlined"
                                                                value={serverImageType}
                                                                onChange={handleServerImageTypeChange}
                                                                style={{ width: '180px' }}
                                                                disabled={Boolean(currentMarketStack)}
                                                            >
                                                                <MenuItem value={IMAGE_TYPE.HEIDI_STACK}>Heidi Stack</MenuItem>
                                                                <MenuItem value={IMAGE_TYPE.CUSTOM_STACK}>Custom Stack</MenuItem>
                                                            </SelectFormsy>
                                                        </div>
                                                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginTop: '16px' }}>
                                                            <SelectFormsy
                                                                className={clsx(classes.input)}
                                                                id="aws_image_mode"
                                                                name="image_mode"
                                                                label="Image Mode"
                                                                type="select"
                                                                variant="outlined"
                                                                value={imageMode}
                                                                onChange={e => setImageMode(e.target.value)}
                                                                style={{ width: '220px' }}
                                                                disabled={Boolean(currentMarketStack)}
                                                            >
                                                                <MenuItem value={IMAGE_MODE.MULTI_IMAGE}>Multi-Image (Legacy)</MenuItem>
                                                                <MenuItem value={IMAGE_MODE.UNIFIED}>Unified (Single Image)</MenuItem>
                                                            </SelectFormsy>
                                                            <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px', maxWidth: '300px' }}>
                                                                {imageMode === IMAGE_MODE.UNIFIED
                                                                    ? 'Single unified image for head and compute nodes'
                                                                    : 'Separate images for head node and compute nodes'}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                                <div style={columnContainerStyle}>
                                    {/* Left column - VNC Settings */}
                                    <div style={columnStyle}>                                   
                                        {/* Infrastructure Section */}
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon style={{marginRight: '8px', color: '#2196F3'}}>cloud</Icon>
                                                        <Typography style={sectionTitleStyle}>Infrastructure</Typography>
                                                    </Box>
                                                }
                                                action={
                                                    /* Zone Availability Indicator - shows when zone is selected */
                                                    form && form.data && form.data.network && form.data.network.zone_id && (
                                                        <ZoneAvailabilityIndicator
                                                            isLoading={isAvailabilityLoading}
                                                            isAvailable={unableToVerify ? null : isZoneAvailable(form.data.network.zone_id)}
                                                            missingInstances={getMissingInstances(form.data.network.zone_id)}
                                                            error={availabilityError}
                                                            unableToVerify={unableToVerify}
                                                        />
                                                    )
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                <div className="flex gap-4 mb-16">
                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1 mr-16")}
                                                        id="aws_credential_id"
                                                        name="credential_id"
                                                        label="AWS Credentials"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.credential_id}
                                                        onChange={handleChange}
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        {filteredCredentials.map((c, i) => (
                                                            <MenuItem id={c.name} key={i} value={c.id}>
                                                                {c.name}
                                                            </MenuItem>
                                                        ))}
                                                    </SelectFormsy>
                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1 mr-16")}
                                                        id="aws_region_id"
                                                        name="region_id"
                                                        label="Region"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.network.region_id}
                                                        onChange={e => {
                                                            const newRegionId = e.target.value;
                                                            setNetworkObj(e.target);
                                                            setSelectedRegionId(newRegionId);
                                                        }}
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        {
                                                        regions
                                                            .filter(region =>
                                                                !currentMarketStack ||
                                                                !hasMarketplaceImages ||
                                                                marketplaceRegionIds.length === 0 ||
                                                                marketplaceRegionIds.includes(region.region_id)
                                                            )
                                                            .map((region) => (
                                                                <MenuItem
                                                                    id={`region-${region.region_id}`}
                                                                    key={region.region_id}
                                                                    value={region.region_id}
                                                                >
                                                                    {region.name}
                                                                </MenuItem>
                                                            ))
                                                        }
                                                    </SelectFormsy>

                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1")}
                                                        disabled={isZoneDisabled}
                                                        id="aws_zone_id"
                                                        name="zone_id"
                                                        label={getZoneLabel(form.data.network.region_id, form.data.network.subnet_id, form.data.network.vpc_id)}
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.network.zone_id || ''}
                                                        onChange={e => {
                                                            setNetworkObj(e.target);
                                                            
                                                            // Update the form with new zone
                                                            const updatedForm = {
                                                                ...form,
                                                                data: {
                                                                    ...form.data,
                                                                    network: {
                                                                        ...form.data.network,
                                                                        zone_id: e.target.value
                                                                    }
                                                                }
                                                            };
                                                            
                                                            // Check for EFA conflicts and disable if zones are different
                                                            const groups = [...updatedForm.data.node.group];
                                                            checkAndDisableEFAForDifferentZones(groups);
                                                            updatedForm.data.node.group = groups;
                                                            
                                                            setForm(updatedForm);
                                                        }}
                                                        required={
                                                            !form.data.network.subnet_id &&
                                                            !form.data.network.vpc_id &&
                                                            zones.length !== 0
                                                        }
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem id="aws_none" value="">
                                                            None
                                                        </MenuItem>
                                                        {
                                                            zones
                                                                .map((zone, index) => {
                                                                    const zoneIsAvailable = isZoneAvailable(zone.zone_id);
                                                                    const missingInsts = getMissingInstances(zone.zone_id);
                                                                    return (
                                                                        <MenuItem 
                                                                            id={`zone-${zone.zone_id}`} 
                                                                            key={index} 
                                                                            value={zone.zone_id}
                                                                            disabled={!zoneIsAvailable}
                                                                            style={!zoneIsAvailable ? { opacity: 0.5 } : {}}
                                                                        >
                                                                            <ZoneMenuItemContent
                                                                                zoneName={zone.name}
                                                                                zoneId={zone.zone_id}
                                                                                isAvailable={zoneIsAvailable}
                                                                                missingInstances={missingInsts}
                                                                                showDetails={true}
                                                                            />
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                    </SelectFormsy>
                                                </div>

                                                <div style={inputGroupStyle}>
                                                    {/* Head Node Size custom component with search */}
                                                    <div 
                                                        ref={headNodeInputRef}
                                                        className={clsx(classes.input)} 
                                                        style={{ position: 'relative', flex: 1 }}
                                                    >
                                                        <TextField
                                                            id="aws_server-instance_id"
                                                            label="Head Node Size"
                                                            variant="outlined"
                                                            fullWidth
                                                            required
                                                            value={headNodeSearch}
                                                            onClick={toggleHeadNodeDropdown}
                                                            onChange={handleHeadNodeSearchChange}
                                                            placeholder="Search instance types..."
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        {headNodeSearch && (
                                                                            <IconButton 
                                                                                size="small" 
                                                                                onClick={clearHeadNodeSearch}
                                                                                style={{ padding: '4px' }}
                                                                            >
                                                                                <Icon fontSize="small">clear</Icon>
                                                                            </IconButton>
                                                                        )}
                                                                        <IconButton onClick={toggleHeadNodeDropdown}>
                                                                            <Icon>{headNodeDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                        {headNodeDropdownOpen && (
                                                            <Paper 
                                                                style={{ 
                                                                    position: 'absolute', 
                                                                    zIndex: 1000, 
                                                                    width: '100%', 
                                                                    maxHeight: 300, 
                                                                    overflow: 'auto' 
                                                                }}
                                                            >
                                                                {filteredServerInstances
                                                                    .filter(s => !marketplaceInstanceIds || marketplaceInstanceIds.length === 0 || marketplaceInstanceIds.includes(s.instance_id))
                                                                    .map((s, i) => (
                                                                        <MenuItem
                                                                            id={`server-${s.name}`}
                                                                            key={i}
                                                                            value={s.instance_id}
                                                                            selected={form.data.server.instance_id === s.instance_id}
                                                                            onClick={() => selectHeadNodeInstance(s.instance_id)}
                                                                        >
                                                                            {s.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                {filteredServerInstances.length === 0 && (
                                                                    <MenuItem disabled>
                                                                        No matching instance types
                                                                    </MenuItem>
                                                                )}
                                                            </Paper>
                                                        )}
                                                        <input 
                                                            type="hidden" 
                                                            name="instance_id" 
                                                            value={form.data.server.instance_id || ''} 
                                                        />
                                                    </div>
                                                </div>

                                                {form?.info?.fsr_snapshot_ids?.server && (
                                                    <Box mt={2} p={2} bgcolor="#f5f5f5" borderRadius="4px">
                                                        <Typography variant="subtitle2" style={{marginBottom: '8px', fontWeight: 600}}>
                                                            Fast Snapshot Restore:
                                                        </Typography>
                                                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                                            <Chip 
                                                                label={`Server: ${form.info.fsr_snapshot_ids.server}`}
                                                                size="small"
                                                                style={infoChipStyle}
                                                            />
                                                            {form?.info?.fsr_snapshot_ids?.node?.length > 0 && (
                                                                <Chip 
                                                                    label={`Nodes: ${form.info.fsr_snapshot_ids.node.join(", ")}`}
                                                                    size="small"
                                                                    style={infoChipStyle}
                                                                />
                                                            )}
                                                        </div>
                                                    </Box>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </div>
                                    {/* Right Column */}
                                    <div style={columnStyle}>
                                        {/* Resource Manager Configuration - Replaces Moab Configuration */}
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon style={{marginRight: '8px', color: '#2196F3'}}>settings_applications</Icon>
                                                        <Typography style={sectionTitleStyle}>Resource Manager Configuration</Typography>
                                                    </Box>
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                <div className='flex gap-4 mb-16'>
                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1 mr-16")}
                                                        id="aws_manager"
                                                        name="manager"
                                                        label="Manager"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.manager}
                                                        onChange={e => setDataObj(e.target)}
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 200 }
                                                            }
                                                        }}
                                                    >   
                                                        <MenuItem id="aws_none" value="none">
                                                            None
                                                        </MenuItem>
                                                        <MenuItem id="aws_slurm" value="slurm">
                                                            Slurm
                                                        </MenuItem>
                                                        <MenuItem id="aws_torque" value="torque">
                                                            Torque
                                                        </MenuItem>
                                                    </SelectFormsy>
                                                    <TextField
                                                        className={clsx(classes.input, "flex-1 mr-16")}
                                                        id="aws_hostname"
                                                        name="hostname"
                                                        label="Host Name"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.hostname || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder="Host Name"
                                                        onChange={e => setClusterInfo(e)}
                                                        error={saveAttempted && form.data.manager === RESOURCE_MANAGER.TORQUE && (!form.data.moab?.hostname || form.data.moab.hostname.trim() === '')}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                // Prevent any click interactions when disabled
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                    />
                                                    <TextField
                                                        className={clsx(classes.input, "flex-1")}
                                                        id="aws_ip"
                                                        name="ip"
                                                        label={form.data.server.isPrivate ? 'Private IP' : 'Public IP'}
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.ip || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder={form.data.server.isPrivate ? 'Private IP' : 'Public IP'}
                                                        onChange={e => setClusterInfo(e)}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                // Prevent any click interactions when disabled
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                        error={Boolean(
                                                            saveAttempted && form.data.manager === RESOURCE_MANAGER.TORQUE && (
                                                                !form.data.moab?.ip || 
                                                                form.data.moab.ip.trim() === '' ||
                                                                (form.data.moab.ip && !ipValid(form.data.moab.ip))
                                                            )
                                                        )}
                                                    />
                                                </div>
                                                
                                                {moabIsIntegrated && !currentMarketStack && (
                                                    <Box mt={2} sx={form.data.manager !== RESOURCE_MANAGER.TORQUE ? { opacity: 0.6 } : {}}>
                                                        <Typography variant="subtitle2" style={{marginBottom: '8px'}}>Bursting Configuration:</Typography>
                                                        <FormControl component="fieldset">
                                                            <RadioGroup
                                                                row
                                                                id="aws_burstOnDeploy"
                                                                name="burstOnDeploy"
                                                                value={burstMode}
                                                                onChange={e => {
                                                                    const mode = e.target.value
                                                                    setBurstMode(mode)
                                                                }}
                                                            >
                                                                <FormControlLabel 
                                                                    value="off" 
                                                                    id="aws_radio-off" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Off" 
                                                                    disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                                />
                                                                <FormControlLabel 
                                                                    value="min" 
                                                                    id="aws_radio-min" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Min" 
                                                                    disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                                />
                                                                <FormControlLabel 
                                                                    value="max" 
                                                                    id="aws_radio-max" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Max" 
                                                                    disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                                />
                                                                <FormControlLabel 
                                                                    value="all" 
                                                                    id="aws_radio-all" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="All" 
                                                                    disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>

                                {/* Advanced Options: VNC Settings and Provisioning Script (two columns) */}
                                {advanced && (
                                    <div style={columnContainerStyle}>
                                        {/* Left column - VNC Settings */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>desktop_windows</Icon>
                                                            <Typography style={sectionTitleStyle}>VNC Settings</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={isVncTokenAuthentication}
                                                                    onChange={event => {
                                                                        const newValue = event.target.checked; 
                                                                        setIsVncTokenAuthentication(newValue); 
                                                                        setForm(prevForm => ({
                                                                            ...prevForm,
                                                                            info: {
                                                                                ...prevForm.info,
                                                                                vncTokenAuthentication: newValue 
                                                                            }
                                                                        }));
                                                                    }}
                                                                    name="vncTokenAuthentication"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="Token Authentication"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={isVncRemoteClient}
                                                                    onChange={event => {
                                                                        const newValue = event.target.checked;
                                                                        setIsVncRemoteClient(newValue);
                                                                        setForm(prevForm => ({
                                                                            ...prevForm,
                                                                            info: {
                                                                                ...prevForm.info,
                                                                                vncRemoteClient: newValue
                                                                            }
                                                                        }));
                                                                    }}
                                                                    name="vncRemoteClient"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="Remote Client"
                                                        />
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        
                                        {/* Right column - Provisioning Script (hidden for marketplace apps with hide_provision_script) */}
                                        {!marketplaceHideProvisionScript && (
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>code</Icon>
                                                            <Typography style={sectionTitleStyle}>Provisioning Script</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <div className="flex items-center mb-2">
                                                        <div className="flex-grow">
                                                            <input
                                                                className={classes.uploadInput}
                                                                onChange={e => handleUpload(e)}
                                                                id="aws_upload-btn"
                                                                type="file"
                                                                disabled={disableScriptModification}
                                                            />
                                                            <label htmlFor="aws_upload-btn">
                                                                <Button
                                                                    id="aws_upload-label"
                                                                    component="span"
                                                                    variant="contained"
                                                                    className={classes.grayButton}
                                                                    startIcon={<Icon>cloud_upload</Icon>}
                                                                    disabled={disableScriptModification}
                                                                >
                                                                    Upload Script
                                                                </Button>
                                                            </label>
                                                        </div>
                                                        
                                                        {!form.data.provision.script ? (
                                                            <Typography variant="body2" color="textSecondary">
                                                                No Script
                                                            </Typography>
                                                        ) : (
                                                            <div className="flex items-center">
                                                                <Chip 
                                                                    label="Script Uploaded" 
                                                                    color="primary" 
                                                                    size="small"
                                                                    style={{marginRight: '8px'}}
                                                                />
                                                                {!disableScriptModification && (
                                                                    <IconButton size="small" onClick={handleDeleteScript}>
                                                                        <Icon fontSize="small">delete</Icon>
                                                                    </IconButton>
                                                                )}
                                                                <IconButton id="script-actions-view-button" size="small" onClick={() => setScriptOpen(true)}>
                                                                    <Icon fontSize="small">visibility</Icon>
                                                                </IconButton>
                                                            </div>
                                                        )}
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        )}
                                    </div>
                                )}

                                {/* Global Provision Scripts Preview - Feature 002 Enhancement */}
                                {/* Always render when disable_global_scripts is set (so configs load for auto-exclude), but hide the UI */}
                                {(advanced || marketplaceDisableGlobalScripts) && (
                                    <div style={marketplaceDisableGlobalScripts ? { display: 'none' } : undefined}>
                                        <GlobalProvisionScriptsPreview
                                            provider="aws"
                                            osType={form?.info?.['os-type'] || ''}
                                            clusterName={form?.name || ''}
                                            clusterId={form?.id}
                                            excludedScripts={excludedGlobalScripts}
                                            onExcludedScriptsChange={setExcludedGlobalScripts}
                                            disabled={disableInputs || marketplaceDisableGlobalScripts}
                                        />
                                    </div>
                                )}

                                {/* Cluster Applications - visible in both Basic and Advanced modes when apps exist */}
                                {(advanced || clusterApplications.length > 0) && (
                                    <ClusterApplicationsSection
                                        applications={clusterApplications}
                                        onChange={setClusterApplications}
                                        disabled={disableInputs}
                                        cardStyle={cardStyle}
                                        cardHeaderStyle={cardHeaderStyle}
                                        sectionTitleStyle={sectionTitleStyle}
                                    />
                                )}

                                {/* Network Settings and Capacity Reservations - Side by Side */}
                                {advanced && (
                                    <div style={columnContainerStyle}>
                                        {/* Left column - Network Settings */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>cloud_queue</Icon>
                                                            <Typography style={sectionTitleStyle}>Network Settings</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={enableNodeInternetAccess}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked;
                                                                    setEnableNodeInternetAccess(newValue);
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        data: {
                                                                            ...prevForm.data,
                                                                            network: {
                                                                                ...prevForm.data.network,
                                                                                enable_node_internet_access: newValue
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                name="enableNodeInternetAccess"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={
                                                            <Box>
                                                                <Typography variant="body1" style={{fontWeight: 500}}>
                                                                    Enable Node Internet Access
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                    Create NAT Gateway for outbound internet connectivity.
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />
                                                </CardContent>
                                            </Card>
                                        </div>

                                        {/* Right column - Capacity Reservations */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>how_to_reg</Icon>
                                                            <Typography style={sectionTitleStyle}>Capacity Reservations</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={enableCapacityReservation}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked;
                                                                    setEnableCapacityReservation(newValue);
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        data: {
                                                                            ...prevForm.data,
                                                                            network: {
                                                                                ...prevForm.data.network,
                                                                                enable_capacity_reservation: newValue
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                name="enableCapacityReservation"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={
                                                            <Box>
                                                                <Typography variant="body1" style={{fontWeight: 500}}>
                                                                    Reserve Capacity Before Deploy
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                    Validate instance availability before deployment.
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />

                                                    {/* Auto-Expire Options (only shown when capacity reservation is enabled) */}
                                                    {enableCapacityReservation && (
                                                        <Box mt={2} ml={4} p={2} style={{backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={capacityReservationAutoExpire}
                                                                        onChange={event => {
                                                                            const newValue = event.target.checked;
                                                                            setCapacityReservationAutoExpire(newValue);
                                                                            setForm(prevForm => ({
                                                                                ...prevForm,
                                                                                data: {
                                                                                    ...prevForm.data,
                                                                                    network: {
                                                                                        ...prevForm.data.network,
                                                                                        capacity_reservation_auto_expire: newValue
                                                                                    }
                                                                                }
                                                                            }));
                                                                        }}
                                                                        name="capacityReservationAutoExpire"
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={
                                                                    <Box>
                                                                        <Typography variant="body2" style={{fontWeight: 500}}>
                                                                            Auto-Expire (Safety Net)
                                                                        </Typography>
                                                                        <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                            Prevent orphaned capacity charges if deployment fails.
                                                                        </Typography>
                                                                    </Box>
                                                                }
                                                            />

                                                            {/* Expire Hours TextField (only shown when auto-expire is enabled) */}
                                                            {capacityReservationAutoExpire && (
                                                                <Box mt={1} ml={4}>
                                                                    <TextField
                                                                        type="number"
                                                                        label="Expiration Hours"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={capacityReservationExpireHours}
                                                                        onChange={event => {
                                                                            const newValue = parseInt(event.target.value, 10) || 1;
                                                                            setCapacityReservationExpireHours(newValue);
                                                                            setForm(prevForm => ({
                                                                                ...prevForm,
                                                                                data: {
                                                                                    ...prevForm.data,
                                                                                    network: {
                                                                                        ...prevForm.data.network,
                                                                                        capacity_reservation_expire_hours: newValue
                                                                                    }
                                                                                }
                                                                            }));
                                                                        }}
                                                                        inputProps={{ min: 1, max: 24 }}
                                                                        style={{width: '200px'}}
                                                                        helperText="Hours (1-24)"
                                                                    />
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                )}

                                {/* Storage Settings */}
                                {advanced && (
                                    <Card style={cardStyle}>
                                        <CardHeader
                                            title={
                                                <Box display="flex" alignItems="center">
                                                    <Icon style={{marginRight: '8px', color: '#2196F3'}}>storage</Icon>
                                                    <Typography style={sectionTitleStyle}>Storage Settings</Typography>
                                                </Box>
                                            }
                                            style={cardHeaderStyle}
                                        />
                                        <CardContent>
                                            <div style={inputGroupStyle}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{flex: 1}}
                                                    id="aws_server-volume_size"
                                                    name="volume_size"
                                                    label="Server Volume (GB)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.server.volume_size}
                                                    onChange={e => setServerObj(e.target)}
                                                    placeholder={`Disk size of the Cluster Head Node (Min: ${providerVolsize.min}, Max: ${providerVolsize.max})`}
                                                    validations={{
                                                        mustbenumber: (formValues, fieldValue) => {
                                                            return validationInput(
                                                                'clusterservervolume',
                                                                formValues.instance_id,
                                                                fieldValue,
                                                                1,
                                                                "aws",
                                                                currentMarketStack
                                                            );
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustbenumber: validationMess('clusterservervolume', form.instance_id, 1, "aws", currentMarketStack)
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{flex: 1}}
                                                    id="aws_node-volume_size"
                                                    name="volume_size"
                                                    label="Node Volume (GB)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.node.volume_size}
                                                    onChange={e => setNodeObj(e.target)}
                                                    placeholder={`Disk size of the Cluster Nodes (Min: ${providerVolsize.min}, Max: ${providerVolsize.max})`}
                                                    validations={{
                                                        mustbenumber: (formValues, fieldValue) => {
                                                            const minValue = currentMarketStack?.config?.node_volume ? currentMarketStack?.config?.node_volume : 1;
                                                            return validationInput('clusternodevolume', formValues.instance_id, fieldValue, minValue, "aws", currentMarketStack);
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustbenumber: validationMess('clusternodevolume', form.instance_id, currentMarketStack?.config?.node_volume ? currentMarketStack?.config?.node_volume : 1, "aws", currentMarketStack)
                                                    }}
                                                />
                                                <SelectFormsy
                                                    className={clsx(classes.input)}
                                                    style={{flex: 1}}
                                                    id="aws_share"
                                                    name="share"
                                                    label="Shared File System"
                                                    type="select"
                                                    variant="outlined"
                                                    value={form.data.share}
                                                    onChange={e => setDataObj(e.target)}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { maxHeight: 300 }
                                                        }
                                                    }}
                                                >
                                                    <MenuItem id="aws_nfs" value="nfs">
                                                        NFS
                                                    </MenuItem>
                                                    <MenuItem id="aws_beegfs" value="beegfs">
                                                        BeeGFS
                                                    </MenuItem>
                                                </SelectFormsy>
                                            </div>
                                            <div style={inputGroupStyle}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{flex: 1}}
                                                    id="aws_idle_purge_s"
                                                    name="idle_purge_s"
                                                    label="Idle Purge Time (S)"
                                                    type="number"
                                                    variant="outlined"
                                                    value={form.data.node.idle_purge_s}
                                                    onChange={e => setNodeObj(e.target)}
                                                    inputProps={{
                                                        min: 0
                                                    }}
                                                />
                                            </div>
                                        </CardContent>
                                    </Card>
                                )}

                                {/* Storage Configuration */}
                                {advanced && ['ubuntu-22.04', 'ubuntu-24.04'].includes(form?.info?.['os-type']) && (
                                    <StorageConfigurationSection 
                                        form={form} 
                                        setForm={setForm}
                                        disabled={disableInputs}
                                        zones={zones}
                                        onStorageConfigurationChange={handleStorageConfigurationChange}
                                        cloudProvider="aws"
                                    />
                                )}

                                {/* Head Node Performance Data Storage - Only show if storage configs are available */}
                                {availableStorageConfigs && availableStorageConfigs.length > 0 && (
                                    <Card style={cardStyle}>
                                        <CardHeader
                                            title={
                                                <Box display="flex" alignItems="center">
                                                    <Icon style={{marginRight: '8px', color: '#2196F3'}}>storage</Icon>
                                                    <Typography style={sectionTitleStyle}>Head Node Performance Data Storage</Typography>
                                                </Box>
                                            }
                                            style={cardHeaderStyle}
                                        />
                                        <CardContent>
                                            <Typography variant="body2" color="textSecondary" style={{marginBottom: '16px'}}>
                                                Attach high-performance storage to head node.
                                            </Typography>

                                            {/* Display existing head node volumes with inline switch */}
                                            {form.data?.server?.attachedVolumes && form.data.server.attachedVolumes.length > 0 ? (
                                                <Box mb={2}>
                                                    {form.data.server.attachedVolumes.map((volume, volIndex) => {
                                                        if (!volume) return null;
                                                        const storageConfig = availableStorageConfigs.find(config => config.id === volume.storageConfigId);
                                                        const storageConfigName = storageConfig?.name || 'Unknown Storage';
                                                        
                                                        return (
                                                            <Box 
                                                                key={volume.id || `volume-${volIndex}`}
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="space-between"
                                                                mb={1}
                                                            >
                                                                {/* Blue rounded chip with volume info and edit/delete icons */}
                                                                <div style={{
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    backgroundColor: '#E3F2FD',
                                                                    borderRadius: '16px',
                                                                    padding: '4px 10px',
                                                                    height: '26px',
                                                                    border: '1px solid #BBDEFB',
                                                                    marginRight: '8px',
                                                                    marginBottom: '4px'
                                                                }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '8px' }}>
                                                                        <Typography variant="body2" style={{
                                                                            fontSize: '12px',
                                                                            fontWeight: 500,
                                                                            color: '#1565C0',
                                                                            maxWidth: '200px',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap'
                                                                        }}>
                                                                            {`${storageConfigName} (${volume.size}GB)`}
                                                                        </Typography>
                                                                    </div>
                                                                    
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                                        {/* Edit Icon inside chip */}
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                openHeadVolumeEditDialog(volume);
                                                                            }}
                                                                            style={{
                                                                                padding: '1px',
                                                                                width: '16px',
                                                                                height: '16px',
                                                                                color: '#1976D2',
                                                                                backgroundColor: 'rgba(25, 118, 210, 0.1)'
                                                                            }}
                                                                        >
                                                                            <Icon style={{ fontSize: '11px' }}>edit</Icon>
                                                                        </IconButton>
                                                                        
                                                                        {/* Delete Icon inside chip */}
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                removeVolumeFromHeadNode(volume.id);
                                                                            }}
                                                                            style={{
                                                                                padding: '1px',
                                                                                width: '16px',
                                                                                height: '16px',
                                                                                color: '#D32F2F',
                                                                                backgroundColor: 'rgba(211, 47, 47, 0.1)'
                                                                            }}
                                                                        >
                                                                            <Icon style={{ fontSize: '11px' }}>delete</Icon>
                                                                        </IconButton>
                                                                    </div>
                                                                </div>

                                                                {/* Bigger switch and info icon outside chip on the right */}
                                                                <Box display="flex" alignItems="center" style={{ marginLeft: '16px', gap: '12px' }}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={volume.enablePerformanceDataSharing || false}
                                                                                onChange={(e) => {
                                                                                    const updatedForm = _.cloneDeep(form);
                                                                                    if (updatedForm.data.server.attachedVolumes[volIndex]) {
                                                                                        updatedForm.data.server.attachedVolumes[volIndex].enablePerformanceDataSharing = e.target.checked;
                                                                                        setForm(updatedForm);
                                                                                    }
                                                                                }}
                                                                                color="primary"
                                                                            />
                                                                        }
                                                                        label={
                                                                            <Typography variant="body1" style={{fontWeight: 500, fontSize: '14px'}}>
                                                                                Share via NFS
                                                                            </Typography>
                                                                        }
                                                                    />
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => setPdsInfoPopoverAnchorEl(e.currentTarget)}
                                                                    >
                                                                        <Icon style={{fontSize: '20px', color: '#2196F3'}}>info</Icon>
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        );
                                                    })}
                                                </Box>
                                            ) : (
                                                <Box mb={2} p={2} style={{backgroundColor: '#f5f5f5', borderRadius: '4px', border: '1px dashed #e0e0e0'}}>
                                                    <Typography variant="body2" color="textSecondary" style={{fontStyle: 'italic'}}>
                                                        No volumes attached
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* Info Popover */}
                                            <Popover
                                                open={pdsInfoPopoverOpen}
                                                anchorEl={pdsInfoPopoverAnchorEl}
                                                onClose={() => setPdsInfoPopoverAnchorEl(null)}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                            >
                                                <Box p={2} style={{maxWidth: '400px'}}>
                                                    <Typography variant="subtitle2" style={{fontWeight: 600, marginBottom: '8px'}}>
                                                        Performance Data Storage
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        When enabled, this volume will be automatically shared with all compute nodes via NFS (Network File System). The volume will be mounted at the same path on all nodes, allowing for shared high-performance data access across your cluster. This is ideal for:
                                                    </Typography>
                                                    <ul style={{marginTop: '8px', marginBottom: '8px', paddingLeft: '20px'}}>
                                                        <li><Typography variant="body2" color="textSecondary">Shared datasets and input files</Typography></li>
                                                        <li><Typography variant="body2" color="textSecondary">Intermediate computation results</Typography></li>
                                                        <li><Typography variant="body2" color="textSecondary">Checkpoints and logs</Typography></li>
                                                        <li><Typography variant="body2" color="textSecondary">Collaborative workspaces</Typography></li>
                                                    </ul>
                                                    <Typography variant="body2" color="textSecondary">
                                                        All nodes will have read/write access to the shared storage with full permissions (777).
                                                    </Typography>
                                                </Box>
                                            </Popover>

                                            {/* Add Volume Button - Only show if no volume exists (max 1) */}
                                            {(!form.data.server.attachedVolumes || form.data.server.attachedVolumes.length === 0) && (
                                                <Box>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        startIcon={<Icon>add</Icon>}
                                                        onClick={handleHeadNodeVolumeDropdownOpen}
                                                        disabled={availableStorageConfigs.length === 0}
                                                    >
                                                        Add Volume
                                                    </Button>

                                                    {/* Storage Config Selection Popover */}
                                                    <Popover
                                                        open={headNodeVolumeDropdownOpen}
                                                        anchorEl={headNodeVolumeDropdownAnchorEl.current}
                                                        onClose={handleHeadNodeVolumeDropdownClose}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        }}
                                                    >
                                                        <Box p={1}>
                                                            <Typography variant="subtitle2" style={{padding: '8px', fontWeight: 600}}>
                                                                Select Storage Configuration
                                                            </Typography>
                                                            {availableStorageConfigs.map((config) => (
                                                                <MenuItem
                                                                    key={config.id}
                                                                    onClick={() => handleHeadNodeVolumeConfigSelect(config.id)}
                                                                >
                                                                    {config.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Box>
                                                    </Popover>

                                                    {availableStorageConfigs.length === 0 && (
                                                        <Typography variant="caption" color="textSecondary" style={{marginTop: '8px', display: 'block'}}>
                                                            No storage configurations available. Create one in the Storage Configuration section above.
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )}
                                        </CardContent>
                                    </Card>
                                )}

                                {/* Compute Nodes Section */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Box display="flex" alignItems="center">
                                                    <Icon style={{marginRight: '8px', color: '#2196F3'}}>device_hub</Icon>
                                                    <Typography style={sectionTitleStyle}>Compute Nodes</Typography>
                                                    <Tooltip title="The available Regions, Availability Zones, Server Instance Sizes, Compute Node Instance Sizes and quantity of Instances may vary based on your provider account status.">
                                                        <Icon style={tooltipIconStyle}>help_outline</Icon>
                                                    </Tooltip>
                                                </Box>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    startIcon={<Icon>add</Icon>}
                                                    onClick={addComputeNode}
                                                    disabled={form.data.node.group.length >= 250}
                                                    className={classes.grayButton}
                                                >
                                                    Add Node Group
                                                </Button>
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                        {nodeInstanceSizes && form.data.node.group
                                            .filter((val, index, array) => {
                                                // Remove duplicate media groups - keep only the first occurrence of each unique group
                                                if (val.nodeType === 'media') {
                                                    const firstOccurrenceIndex = array.findIndex(group => 
                                                        group.nodeType === 'media' && 
                                                        group.instance_id === val.instance_id &&
                                                        group.storageReference === val.storageReference
                                                    );
                                                    return firstOccurrenceIndex === index;
                                                }
                                                return true; // Keep all non-storage groups
                                            })
                                            .sort((a, b) => {
                                                // Sort regular groups first, then media groups
                                                const aIsMedia = a.nodeType === 'media';
                                                const bIsMedia = b.nodeType === 'media';
                                                
                                                if (aIsMedia && !bIsMedia) return 1;  // a is media, b is regular -> b comes first
                                                if (!aIsMedia && bIsMedia) return -1; // a is regular, b is media -> a comes first
                                                return 0; // Both are same type, maintain original order
                                            })
                                            .map((val, i) => {
                                                // Check if this node group should be disabled
                                                const isStorageManaged = val.nodeType === 'media';
                                                const nodeGroupId = `node-${i}`;
                                                const isNewlyAdded = newlyAddedNodeGroups.has(nodeGroupId);
                                                
                                                // Define animation styles
                                                const fadeInKeyframes = `
                                                    @keyframes fadeInNodeGroup {
                                                        0% { opacity: 0.5; }
                                                        100% { opacity: 1; }
                                                    }
                                                `;
                                                
                                                return (
                                                <div
                                                    key={`node-${i}`}
                                                    style={{
                                                        position: 'relative',
                                                        marginBottom: '16px',
                                                        animation: isNewlyAdded ? 'fadeInNodeGroup 1.05s ease-in-out' : 'none'
                                                    }}
                                                >
                                                    {/* Inject keyframes into the document head if this is a newly added node */}
                                                    {isNewlyAdded && (
                                                        <style>
                                                            {fadeInKeyframes}
                                                        </style>
                                                    )}
                                                    <Paper
                                                        elevation={1}
                                                        style={{
                                                            padding: '16px',
                                                            borderLeft: val.nodeType === 'media'
                                                                ? '4px solid #2E7D32' 
                                                                : '4px solid #e0e0e0',
                                                            backgroundColor: isStorageManaged ? '#fafafa' : 'white',
                                                            opacity: 1,
                                                            filter: 'none',
                                                            pointerEvents: isStorageManaged ? 'none' : 'auto'
                                                        }}
                                                    >
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                    <Box display="flex" alignItems="center" style={{gap: '8px'}}>
                                                        <Typography variant="subtitle1" style={{ 
                                                            fontWeight: 500,
                                                            color: val.nodeType === 'media'
                                                                ? '#1B5E20' 
                                                                : 'inherit'
                                                        }}>
                                                            {val.group_node_prefix_label || `Node Group ${i + 1}`}
                                                        </Typography>

                                                    </Box>

                                                    {val.nodeType === 'media' ? (
                                                        <Chip
                                                            label="Media Storage"
                                                            size="small"
                                                            style={{
                                                                backgroundColor: '#2E7D32',
                                                                color: 'white',
                                                                fontWeight: 500
                                                            }}
                                                        />
                                                    ) : (
                                                        <Box display="flex" alignItems="center" style={{gap: '16px'}}>                                                            
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => showDeleteConfirmation(val)}
                                                                disabled={form.data.node.group.length <= 1}
                                                                style={{
                                                                    marginRight: '-7px',
                                                                    color: form.data.node.group.length <= 1 
                                                                        ? 'rgba(0, 0, 0, 0.26)' 
                                                                        : '#9e9e9e'
                                                                }}
                                                                aria-label="remove node group"
                                                            >
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </Box>
                                                    )}
                                                </Box>
                                                
                                                <div style={{...inputGroupStyle, alignItems: 'center'}}>
                                                    {imageMode === IMAGE_MODE.MULTI_IMAGE && (
                                                        <TextField
                                                            ref={el => groupNodePrefixRefs.current[i] = el}
                                                            className={clsx(classes.input)}
                                                            style={{flex: 1}}
                                                            label="Node Stack"
                                                            value={val.storageReference ? (val.group_node_prefix || null) : (groupNodeInputValues[i] || '')}
                                                            onChange={(e) => {
                                                                if (!val.storageReference && !isStorageManaged) {
                                                                    const newValue = e.target.value;
                                                                    setGroupNodeInputValues(prevValues => ({
                                                                        ...prevValues,
                                                                        [i]: newValue
                                                                    }));
                                                                    setNodePrefix(i, newValue);
                                                                    validateNodePrefix(newValue, i);
                                                                }
                                                            }}
                                                            variant="outlined"
                                                            disabled={Boolean(currentMarketStack) || Boolean(val.storageReference) || isStorageManaged}
                                                            required={!val.storageReference}
                                                            error={nodePrefixErrors[i] ? true : false}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            disabled={Boolean(currentMarketStack) || Boolean(val.storageReference) || isStorageManaged}
                                                                            onClick={() => !isStorageManaged && handleGroupNodeMenuOpen(i)}>
                                                                            <ArrowDropDownIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    )}

                                                    <div 
                                                        ref={el => nodeInputRefs.current[i] = el}
                                                        className={clsx(classes.input)} 
                                                        style={{ position: 'relative', flex: 2 }}
                                                    >
                                                        <TextField
                                                            id={`node-size-${i}`}
                                                            label="Instance Type"
                                                            variant="outlined"
                                                            fullWidth
                                                            required
                                                            value={nodeSearchValues[i] || ''}
                                                            onClick={() => !val.storageReference && !isStorageManaged && toggleNodeDropdown(i)}
                                                            onChange={(e) => !val.storageReference && !isStorageManaged && handleNodeSearchChange(i, e)}
                                                            disabled={Boolean(val.storageReference) || isStorageManaged}
                                                            placeholder={val.storageReference ? "Auto-selected for storage configuration" : "Search instance types..."}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        {nodeSearchValues[i] && (
                                                                            <IconButton 
                                                                                size="small" 
                                                                                onClick={() => clearNodeSearch(i)}
                                                                                style={{ padding: '4px' }}
                                                                            >
                                                                                <Icon fontSize="small">clear</Icon>
                                                                            </IconButton>
                                                                        )}
                                                                        <IconButton onClick={() => !isStorageManaged && toggleNodeDropdown(i)}>
                                                                            <Icon>{nodeDropdownOpen[i] ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                        {nodeDropdownOpen[i] && (
                                                            <Paper 
                                                                style={{ 
                                                                    position: 'absolute', 
                                                                    zIndex: 1000, 
                                                                    width: '100%', 
                                                                    maxHeight: 300, 
                                                                    overflow: 'auto' 
                                                                }}
                                                            >
                                                                {filteredNodeInstances
                                                                    .filter(s => !marketplaceComputeIds || marketplaceComputeIds.length === 0 || marketplaceComputeIds.includes(s.instance_id))
                                                                    .map((s, idx) => (
                                                                        <MenuItem
                                                                            id={`server-${s.name}`}
                                                                            key={idx}
                                                                            value={s.instance_id}
                                                                            selected={val.instance_id === s.instance_id}
                                                                            onClick={() => selectNodeInstance(i, s.instance_id)}
                                                                        >
                                                                            {s.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                {filteredNodeInstances.length === 0 && (
                                                                    <MenuItem disabled>
                                                                        No matching instance types
                                                                    </MenuItem>
                                                                )}
                                                            </Paper>
                                                        )}
                                                    </div>

                                                    {isCompatibleForEFA(val.instance_id) && (
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    style={{color: '#2196F3'}}
                                                                    id="aws_efa"
                                                                    name="efa"
                                                                    title="Elastic Fabric Adapter"
                                                                    checked={(isCompatibleForEFA(val.instance_id) && val.efa && !areZonesDifferent())}
                                                                    onChange={() =>
                                                                        !val.storageReference && !isStorageManaged && !areZonesDifferent() && (
                                                                            !isCompatibleForEFA(val.instance_id)
                                                                                ? setEfaForNode(i, false)
                                                                                : setEfaForNode(i, !val.efa)
                                                                        )
                                                                    }
                                                                    disabled={Boolean(val.storageReference) || isStorageManaged || areZonesDifferent()}
                                                                />
                                                            }
                                                            label={
                                                                <Tooltip title={areZonesDifferent() ? "EFA is not supported when nodes are in different zones" : "Enable Elastic Fabric Adapter"}>
                                                                    <span>EFA</span>
                                                                </Tooltip>
                                                            }
                                                        />
                                                    )}

                                                    {imageMode === IMAGE_MODE.MULTI_IMAGE && (
                                                        <SelectFormsy
                                                            className={clsx(classes.input)}
                                                            style={{ width: '180px' }}
                                                            id={`aws_node_image_type_${i}`}
                                                            name={`node_image_type_${i}`}
                                                            label="Image Type"
                                                            type="select"
                                                            variant="outlined"
                                                            value={nodeImageTypes[i] || IMAGE_TYPE.HEIDI_STACK}
                                                            onChange={e => !val.storageReference && !isStorageManaged && setNodeImageType(i, e.target.value)}
                                                            disabled={Boolean(currentMarketStack) || Boolean(val.storageReference) || isStorageManaged}
                                                        >
                                                            <MenuItem value={IMAGE_TYPE.HEIDI_STACK}>Heidi Stack</MenuItem>
                                                            <MenuItem value={IMAGE_TYPE.CUSTOM_STACK}>Custom Stack</MenuItem>
                                                        </SelectFormsy>
                                                    )}

                                                    <TextFieldFormsy
                                                        className={clsx(classes.input)}
                                                        style={{width: '120px'}}
                                                        id={`count-${i}`}
                                                        name="count"
                                                        label="Count"
                                                        type="number"
                                                        variant="outlined"
                                                        value={(() => {
                                                            // For storage-managed nodes, show the calculated count from storage configuration
                                                            if (val.storageReference && form?.data?.storageConfigurations) {
                                                                const matchingStorage = form.data.storageConfigurations.find(config => {
                                                                    const mediaRef = `media-${config.id}`;
                                                                    const appRef = `app-${config.id}`;
                                                                    return val.storageReference === mediaRef || 
                                                                           val.storageReference === appRef;
                                                                });
                                                                
                                                                if (matchingStorage) {
                                                                    // For media nodes, use requiredNodes which includes resiliency calculations
                                                                    if (val.nodeType === 'media') {
                                                                        return matchingStorage.requiredNodes || val.count || '0';
                                                                    }
                                                                }
                                                            }
                                                            // For regular nodes, show the stored count
                                                            return val.count || '0';
                                                        })()}
                                                        onChange={e => !val.storageReference && !isStorageManaged && setInstanceCount(i, e.target, val.instance_id)}
                                                        required
                                                        disabled={Boolean(val.storageReference) || isStorageManaged}
                                                        inputProps={{
                                                            min: 0,
                                                            max: 250
                                                        }}
                                                    />
                                                    
                                                    {/* Hidden fields for storage tracking - using database fields */}
                                                    {val.storageReference && (
                                                        <input
                                                            type="hidden"
                                                            name={`storageReference_${i}`}
                                                            value={val.storageReference}
                                                        />
                                                    )}
                                                    {val.nodeType && val.nodeType !== 'regular' && (
                                                        <input
                                                            type="hidden"
                                                            name={`nodeType_${i}`}
                                                            value={val.nodeType}
                                                        />
                                                    )}
                                                    {val.zone_id && (
                                                        <input
                                                            type="hidden"
                                                            name={`zone_id_${i}`}
                                                            value={val.zone_id}
                                                        />
                                                    )}
                                                </div>

                                                {/* Zone Selection - only show if Infrastructure Region and Availability Zone are selected */}
                                                {form.data.network.region_id && form.data.network.zone_id && (
                                                    <div style={{...inputGroupStyle, marginTop: '12px'}}>
                                                        <SelectFormsy
                                                            className={clsx(classes.input)}
                                                            style={{minWidth: '200px', width: '200px'}}
                                                            id={`aws_node_zone_id_${i}`}
                                                            name={`node_zone_id_${i}`}
                                                            label="Availability Zone"
                                                            type="select"
                                                            variant="outlined"
                                                            value={val.zone_id || form.data.network.zone_id || ''}
                                                            onChange={e => !val.storageReference && !isStorageManaged && setNodeZone(i, e.target.value || form.data.network.zone_id)}
                                                            disabled={Boolean(val.storageReference) || isStorageManaged}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    style: { maxHeight: 300 }
                                                                }
                                                            }}
                                                        >
                                                            <MenuItem value={form.data.network.zone_id || ""}>
                                                                {form.data.network.zone_id ? 
                                                                    `Default Zone (${zones?.find(z => z.zone_id === form.data.network.zone_id)?.name || form.data.network.zone_id})` : 
                                                                    'Default Zone'
                                                                }
                                                            </MenuItem>
                                                            {zones && zones.map((zone, zoneIndex) => {
                                                                const zoneIsAvailable = isZoneAvailable(zone.zone_id);
                                                                const missingInsts = getMissingInstances(zone.zone_id);
                                                                return (
                                                                    <MenuItem 
                                                                        key={zoneIndex} 
                                                                        value={zone.zone_id}
                                                                        id={`node-zone-${zone.zone_id}-${i}`}
                                                                        disabled={!zoneIsAvailable}
                                                                        style={!zoneIsAvailable ? { opacity: 0.5 } : {}}
                                                                    >
                                                                        <ZoneMenuItemContent
                                                                            zoneName={zone.name}
                                                                            zoneId={zone.zone_id}
                                                                            isAvailable={zoneIsAvailable}
                                                                            missingInstances={missingInsts}
                                                                            showDetails={false}
                                                                        />
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        </SelectFormsy>
                                                    </div>
                                                )}

                                                {/* Volume Management for regular node groups - only show if storage configs are available */}
                                                {!isStorageManaged && availableStorageConfigs.length > 0 && (
                                                    <Box mt={2}>
                                                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                                            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                                                                Volumes
                                                            </Typography>
                                                            {/* Add Volume button */}
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                startIcon={<Icon style={{ fontSize: '14px' }}>add</Icon>}
                                                                onClick={(e) => handleVolumeDropdownOpen(e, i)}
                                                                style={{
                                                                    fontSize: '11px',
                                                                    padding: '4px 8px',
                                                                    minWidth: 'auto',
                                                                    height: '28px'
                                                                }}
                                                            >
                                                                Add Volume
                                                            </Button>
                                                            
                                                            {/* Dropdown menu */}
                                                            <Menu
                                                                anchorEl={volumeDropdownAnchorEl.current[i]}
                                                                open={Boolean(volumeDropdownOpen[i])}
                                                                onClose={() => handleVolumeDropdownClose(i)}
                                                                PaperProps={{
                                                                    style: {
                                                                        maxHeight: 300,
                                                                        minWidth: 250
                                                                    }
                                                                }}
                                                            >
                                                                {availableStorageConfigs.map((config) => (
                                                                    <MenuItem 
                                                                        key={config.id} 
                                                                        onClick={() => handleVolumeConfigSelect(i, config.id)}
                                                                    >
                                                                        <Box display="flex" alignItems="center">
                                                                            <Icon style={{ marginRight: 8, fontSize: '16px' }}>storage</Icon>
                                                                            <Box>
                                                                                <Typography variant="body2" style={{ fontSize: '12px' }}>
                                                                                    {config.name || config.providerName || 'Unknown Provider'}
                                                                                </Typography>
                                                                                <Typography variant="caption" color="textSecondary" style={{ fontSize: '10px' }}>
                                                                                    {config.providerType ? config.providerType.toUpperCase() : 'UNKNOWN'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))}
                                                                {availableStorageConfigs.length === 0 && (
                                                                    <MenuItem disabled>
                                                                        No storage providers available
                                                                    </MenuItem>
                                                                )}
                                                            </Menu>
                                                        </Box>
                                                        <VolumeManager
                                                            volumes={val.attachedVolumes || []}
                                                            availableStorageConfigs={availableStorageConfigs}
                                                            onVolumeUpdate={handleVolumeUpdate}
                                                            onVolumeDelete={removeVolumeFromNode}
                                                            nodeGroupIndex={i}
                                                            chipContainerStyle={{
                                                                backgroundColor: 'transparent',
                                                                padding: '12px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #e0e0e0',
                                                                minHeight: '40px'
                                                            }}
                                                        />
                                                    </Box>
                                                )}
                                            </Paper>
                                            
                                            {/* Overlay for disabled storage-managed groups */}
                                            {isStorageManaged && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: 'rgba(250, 250, 250, 0.4)',
                                                        zIndex: 10,
                                                        pointerEvents: 'all',
                                                        cursor: 'not-allowed',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <Typography 
                                                        variant="body2" 
                                                        style={{ 
                                                            color: '#757575',
                                                            fontWeight: 500,
                                                            textAlign: 'center',
                                                            padding: '8px 16px',
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            borderRadius: '4px',
                                                            border: '1px solid #e0e0e0'
                                                        }}
                                                    >
                                                        {(() => {
                                                            // Find the storage configuration that matches this node group
                                                            const matchingStorage = form?.data?.storageConfigurations?.find(config => {
                                                                if (val.storageReference) {
                                                                    let appInstanceTypeMatches = false;
                                                                    
                                                                    // Handle both old (string) and new (array) appInstanceType formats
                                                                    if (Array.isArray(config.appInstanceType)) {
                                                                        appInstanceTypeMatches = config.appInstanceType.some(appGroup => 
                                                                            appGroup.instanceType === val.instance_id
                                                                        );
                                                                    } else if (typeof config.appInstanceType === 'string') {
                                                                        appInstanceTypeMatches = config.appInstanceType === val.instance_id;
                                                                    }
                                                                    
                                                                    return val.storageReference.includes(config.id) || 
                                                                           val.storageReference.includes(config.name) ||
                                                                           config.mediaType === val.instance_id ||
                                                                           appInstanceTypeMatches;
                                                                }
                                                                return false;
                                                            });
                                                            
                                                            const providerType = matchingStorage?.providerType || 'Storage Provider';
                                                            return `Managed by Data Infrastructure`;
                                                        })()}
                                                    </Typography>
                                                </div>
                                            )}
                                        </div>
                                        );
                                    })}
                                    </CardContent>
                                </Card>

                                {/* Description Section */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center">
                                                <Icon style={{marginRight: '8px', color: '#2196F3'}}>description</Icon>
                                                <Typography style={sectionTitleStyle}>Description</Typography>
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                        <TextField
                                            className={clsx(classes.input)}
                                            id="aws_description"
                                            name="description"
                                            label="Cluster Description"
                                            type="textarea"
                                            variant="outlined"
                                            value={form.description}
                                            onChange={handleChange}
                                            fullWidth
                                            multiline
                                            minRows={3}
                                            placeholder="Enter a description for this cluster..."
                                        />
                                    </CardContent>
                                </Card>
                            </Formsy>
                        </DisabledFormWrapper>
                    </DialogContent>
                </React.Fragment>
            )}
            
            {/* Server Stack Dropdown Menu */}
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
                MenuListProps={{
                    'aria-labelledby': 'server-stack-button',
                }}
            >
                {stacks && stacks.length > 0 ? (
                    stacks.map((stack) => (
                        <MenuItem 
                            key={stack.id || stack._id} 
                            onClick={() => {
                                setServerObj({ name: 'image_name', value: stack.data.prefix });
                                validateServerPrefix(stack.data.prefix);
                                handleMenuClose();
                            }}
                        >
                            {stack.data.prefix}{stack.description ? ` - ${stack.description}` : ''}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled>
                        No stacks available
                    </MenuItem>
                )}
            </Menu>

            {/* Node Group Stack Dropdown Menus */}
            {form?.data?.node?.group?.map((val, i) => (
                <Menu
                    key={`node-menu-${i}`}
                    anchorEl={activeMenuIndex === i ? groupNodePrefixRefs.current[i] : null}
                    open={activeMenuIndex === i}
                    onClose={() => setActiveMenuIndex(null)}
                    MenuListProps={{
                        'aria-labelledby': `node-stack-button-${i}`,
                    }}
                >
                    {stacks && stacks.length > 0 ? (
                        stacks.map((stack) => (
                            <MenuItem 
                                key={stack.id || stack._id} 
                                onClick={() => {
                                    handleGroupNodeMenuItemClick(i, stack.data.prefix);
                                    validateNodePrefix(stack.data.prefix, i);
                                }}
                            >
                                {stack.data.prefix}{stack.description ? ` - ${stack.description}` : ''}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>
                            No stacks available
                        </MenuItem>
                    )}
                </Menu>
            ))}
            
            {/* Delete Node Group Confirmation Dialog */}
            <Dialog
                open={confirmDeleteDialogOpen}
                onClose={closeConfirmDeleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Delete Node Group</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this node group? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDeleteNodeGroup} color="primary" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Head node volume details dialog */}
            <VolumeDetailsDialog
                open={headDialogOpen}
                onClose={closeHeadVolumeDialog}
                onSave={saveHeadVolumeDialog}
                volume={headSelectedVolume}
                storageConfig={headSelectedStorageConfig}
                isEditable={headIsEditable}
                nodeGroupIndex={-1}
            />
            
            <ScriptDialog
                open={isScriptOpen}
                onClose={() => setScriptOpen(false)}
                scriptContent={form?.data?.provision?.script || ''}
            />
        </React.Fragment>
    );
};

export default AwsCluster;